import Vue from "vue"
import Router from "vue-router"
/**
 * !!!新路由都将采用懒加载模式，防止加载太慢
 * !!!新路由都将采用懒加载模式，防止加载太慢
 * !!!新路由都将采用懒加载模式，防止加载太慢
 * !!!新路由都将采用懒加载模式，防止加载太慢
 * !!!新路由都将采用懒加载模式，防止加载太慢
 * !!!新路由都将采用懒加载模式，防止加载太慢
 */

Vue.use(Router)
export default new Router({
	mode: "history",
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		}
		return {
			x: 0,
			y: 0
		}
	},
	routes: [
		/*
		{
		    path: '/',
		    name: 'homeNew',
		    component: Home,
		    linkActiveClass: 'active',
		    meta: {
		        title: '首页',
		        //keepAlive: true //此组件不需要被缓存
		    }

		},*/
		{
			path: "/ce",
			name: "ce",
			component: () => import("@/components/ce"),
			linkActiveClass: "active",
			meta: {
				title: "测试"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/",
			name: "homeNew",
			component: () => import("@/components/Home"),
			linkActiveClass: "active",
			meta: {
				title: "美育圈"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/heat_discusss/:parent_id?",
			name: "heatDiscussDetail",
			component: () =>
				import("@/components/artEduCircle/HeatDiscussDetails"),
			linkActiveClass: "active",
			meta: {
				title: "本期热议"
			}
		},
		{
			path: "/home_new_details/:union_id?",
			name: "homeNewDetails",
			component: () => import("@/components/artEduCircle/HomeNewDetails"),
			linkActiveClass: "active",
			meta: {
				title: "美育圈评论"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/top_line",
			name: "topLine",
			component: () => import("@/components/home/TopLine"),
			linkActiveClass: "active",
			meta: {
				title: "汇头条"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/top_line_details/:id?/:DzId?",
			name: "topLineDetails",
			component: () => import("@/components/home/TopLineDetailsNew"),
			linkActiveClass: "active",
			meta: {
				title: "详情"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/top_line_gz/:TopId?/:Type?",
			name: "topLineGZ",
			component: () => import("@/components/home/TopLineGZ"),
			linkActiveClass: "active",
			meta: {
				title: "定制分享"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/top_line_zj/:TopId?/",
			name: "TopLineZJ",
			component: () => import("@/components/home/TopLineZJ"),
			linkActiveClass: "active",
			meta: {
				title: "定制分享"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/top_line_jz/:TopId?/:Type?",
			name: "TopLineJZ",
			component: () => import("@/components/home/TopLineJZ"),
			linkActiveClass: "active",
			meta: {
				title: "定制分享"
				//keepAlive: true //此组件不需要被缓存
			}
		},

		{
			path: "/hot_school/:mygtype/:id",
			name: "hotSchool",
			component: () => import("@/components/home/HotSchool"),
			linkActiveClass: "active",
			meta: {
				title: "附近机构"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/home_search",
			name: "homeSearch",
			component: () => import("@/components/home/HomeSearchNew"),
			linkActiveClass: "active",
			meta: {
				title: "机构搜索"
			}
		},
		{
			path: "/gallery_create/:student_id?",
			name: "galleryCreate",
			component: () => import("@/components/gallery/GalleryCreate"),
			linkActiveClass: "active",
			meta: {
				title: "创建话廊"
			}
		},
		{
			path: "/gallery_list",
			name: "galleryList",
			component: () => import("@/components/gallery/GalleryList"),
			linkActiveClass: "active",
			meta: {
				title: "话廊管理"
			}
		},
		{
			path: "/gallery_success",
			name: "gallerySuccess",
			component: () => import("@/components/gallery/GallerySuccess"),
			linkActiveClass: "active",
			meta: {
				title: "话廊创建成功(未启用)"
			}
		},
		{
			path: "/gallery_clain",
			name: "galleryClain",
			component: () => import("@/components/gallery/GalleryClain"),
			linkActiveClass: "active",
			meta: {
				title: "认领话廊"
			}
		},

		{
			path: "/gallery_footprint_list/:school_id?/:this_week?",
			name: "GalleryFootprintList",
			component: () =>
				import("@/components/gallery/GalleryFootprintListNew"),
			linkActiveClass: "active",
			meta: {
				title: "爱时光列表"
			}
		},
		{
			path: "/gallery_release_footprint/:student_id?",
			name: "GalleryReleaseFootprint",
			component: () =>
				import("@/components/gallery/GalleryReleaseFootprint"),
			linkActiveClass: "active",
			meta: {
				title: "发布爱时光"
			}
		},
		{
			path: "/professor_add_dynamic",
			name: "professorAddDynamic",
			component: () =>
				import("@/components/professor/ProfessorAddDynamic"),
			linkActiveClass: "active",
			meta: {
				title: "发布动态"
			}
		},
		{
			path: "/gallery_footprint_details/:id?",
			name: "GalleryFootprintDetails",
			component: () =>
				import("@/components/gallery/GalleryFootprintDetails"),
			linkActiveClass: "active",
			meta: {
				title: "爱时光详情"
			}
		},
		{
			path: "/gallery_page/:parent_id?",
			name: "galleryPage",
			component: () => import("@/components/gallery/GalleryPage"),
			linkActiveClass: "active",
			meta: {
				title: "超级话廊主页"
			}
		},
		{
			path: "/gallery_page_old/:parent_id?",
			name: "galleryPageold",
			component: () => import("@/components/gallery/GalleryPageold"),
			linkActiveClass: "active",
			meta: {
				title: "话廊主页"
			}
		},
		{
			path: "/gallery_sel_result/:student_id?/:galleryName?/:fromQuery?/:parent_id?/:type_id?", // 参数  话廊的ID / 话廊的名称（学生名称）/不需要显示最上面的下拉框串1 /当前用户的ID / 分享方式（二维码分享1和页面分享）
			name: "gallerySelResult",
			component: () => import("@/components/gallery/MyChild"),
			// component: () => import("@/components/gallery/GallerySelResultNew"),
			linkActiveClass: "active",
			meta: {
				title: "超级话廊主页"
			}
		},
		// {
		//     path: '/gallery_sel_result_old/:student_id?/:galleryName?/:fromQuery?/:parent_id?/:type_id?',    // 参数  话廊的ID / 话廊的名称（学生名称）/不需要显示最上面的下拉框串1 /当前用户的ID / 分享方式（二维码分享1和页面分享）
		//     name: 'gallerySelResult',
		//     component: ()=>import('@/components/gallery/GallerySelResultOld'),
		//     linkActiveClass: 'active',
		//     meta: {
		//         title: '',
		//     }
		// },
		{
			path: "/gallery_work_list/:student_id?/:galleryName?/:this_week?/:num?",
			name: "galleryWorksList",
			component: () => import("@/components/gallery/GalleryWorksListNew"),
			linkActiveClass: "active",
			meta: {
				title: "话廊作品集"
			}
		},
		{
			path: "/matchList/:student_id?",
			name: "MatchList",
			component: () => import("@/components/gallery/MatchList"),
			linkActiveClass: "active",
			meta: {
				title: "我的赛事"
			}
		},
		{
			path: "/galleryLive",
			name: "GalleryLive",
			component: () => import("@/components/gallery/GalleryLive"),
			linkActiveClass: "active",
			meta: {
				title: "话廊直播"
			}
		},
		{
			path: "/pay/gallery_work_details/:work_id?/:parent_id?/:gallery_id?",
			name: "GalleryWorkDetails",
			component: () => import("@/components/gallery/GalleryWorkDetails"),
			linkActiveClass: "active",
			meta: {
				title: "话廊作品详情",
				keepAlive: false //此组件不需要被缓存
			}
		},
		{
			path: "/oneside_gallery",
			name: "oneSideGallery",
			component: () => import("@/components/gallery/OneSideGallery"),
			linkActiveClass: "active",
			meta: {
				title: "身边画室"
			}
		},
		{
			path: "/parent_class",
			name: "ParentClass",
			component: () => import("@/components/gallery/ParentClass"),
			linkActiveClass: "active",
			meta: {
				title: "亲子课堂"
			}
		},
		{
			path: "/favor_gallery_new/:type",
			name: "favorGallerynew",
			component: () => import("@/components/gallery/FavorGalleryNew"),
			linkActiveClass: "active",
			meta: {
				title: "获奖话廊排行榜"
			}
		},
		{
			path: "/ranking",
			name: "ranKing",
			component: () => import("@/components/gallery/ranKing"),
			linkActiveClass: "active",
			meta: {
				title: "人气小明星"
			}
		},
		{
			path: "/wiki",
			name: "Wiki",
			component: () => import("@/components/Wiki"),
			linkActiveClass: "active",
			meta: {
				title: "运营助手"
			}
		},
		{
			path: "/wikilist",
			name: "WikiList",
			component: () => import("@/components/WikiList"),
			linkActiveClass: "active",
			meta: {
				title: "运营助手"
			}
		},
		{
			path: "/wikidetail",
			name: "WikiDetail",
			component: () => import("@/components/WikiDetail"),
			linkActiveClass: "active",
			meta: {
				title: "运营助手"
			}
		},
		{
			path: "/about",
			name: "About",
			component: () => import("@/components/About"),
			linkActiveClass: "active",
			meta: {
				title: "关于我们"
			}
		},
		{
			path: "/storage_clear",
			name: "清除缓存",
			component: () => import("@/components/common/StorageClear"),
			linkActiveClass: "active",
			meta: {
				title: "清除缓存"
			}
		},
		{
			path: "/blog_create",
			name: "BlogCreate",
			component: () => import("@/components/blog/BlogCreate"),
			linkActiveClass: "active",
			meta: {
				title: "文章发布"
			}
		},
		{
			path: "/blog_detail/",
			name: "BlogDetail",
			component: () => import("@/components/blog/BlogDetail"),
			linkActiveClass: "active",
			meta: {
				title: "文章详情"
			}
		},
		{
			path: "/profile_index",
			name: "ProfileIndex",
			component: () => import("@/components/profile/ProfileIndex"),
			linkActiveClass: "active",
			meta: {
				title: "个人中心"
			}
		},
		{
			path: "/profile_index_new",
			name: "ProfileIndexNew",
			component: () =>
				import("@/components/new_profile_v2/NewPersonalHomepage_v2"),
			// component: ProfileIndexNew,
			linkActiveClass: "active",
			meta: {
				title: "个人中心"
			}
		},
		{
			path: "/meiyutianshi",
			name: "meiyutianshi",
			component: () => import("@/components/profile/Meiyutianshi"),
			linkActiveClass: "active",
			meta: {
				title: "个人中心"
			}
		},
		{
			path: "/profile_share/:imgUrl?/:desc?/:code?/:ShareId?/:student_id?",
			name: "ProfileShare",
			component: () => import("@/components/profile/ProfileShare"),
			linkActiveClass: "active",
			meta: {
				title: "分享"
			}
		},
		{
			path: "/profile_agreement",
			name: "ProfileAgreement",
			component: () => import("@/components/profile/ProfileAgreement"),
			linkActiveClass: "active",
			meta: {
				title: "用户注册协议"
			}
		},
		{
			path: "/profile_privacy",
			name: "ProfilePrivacy",
			component: () => import("@/components/profile/ProfilePrivacy"),
			linkActiveClass: "active",
			meta: {
				title: "隐私协议"
			}
		},
		{
			path: "/tax_deduction_explanation",
			name: "TaxDeductionExplanation",
			component: () => import("@/components/profile/TaxDeductionExplanation"),
			linkActiveClass: "active",
			meta: {
				title: "扣税说明"
			}
		},
		{
			path: "/profile_proposal_list",
			name: "ProfileProposalList",
			component: () => import("@/components/profile/ProfileProposalList"),
			linkActiveClass: "active",
			meta: {
				title: "我的建议"
			}
		},
		{
			path: "/evaluate_teacher_list/:student_id?",
			name: "EvaluateTeacherList",
			component: () =>
				import("@/components/profile/EvaluateTeacherListNew"),
			linkActiveClass: "active",
			meta: {
				title: "家长评价"
			}
		},
		{
			path: "/evaluate_teacher_list_month",
			name: "EvaluateTeacherListMonth",
			component: () =>
				import("@/components/profile/EvaluateTeacherListMonth"),
			linkActiveClass: "active",
			meta: {
				title: "家长本月评价"
			}
		},
		{
			path: "/evaluate_teacher_list_past/:student_id?",
			name: "EvaluateTeacherListPast",
			component: () =>
				import("@/components/profile/EvaluateTeacherListPastNew"),
			linkActiveClass: "active",
			meta: {
				title: "往期已评"
			}
		},
		{
			path: "/evaluate_teacher_list_past_wp/:student_id?",
			name: "EvaluateTeacherListPastWp",
			component: () =>
				import("@/components/profile/EvaluateTeacherListPastWp"),
			linkActiveClass: "active",
			meta: {
				title: "往期未评"
			}
		},
		{
			path: "/total_analysis",
			name: "TotalAnalysis",
			component: () => import("@/components/profile/TotalAnalysis"),
			linkActiveClass: "active",
			meta: {
				title: "评教分析"
			}
		},
		{
			path: "/total_analysis_del",
			name: "TotalAnalysisDel",
			component: () => import("@/components/profile/TotalAnalysisDel"),
			linkActiveClass: "active",
			meta: {
				title: "评教分析详情"
			}
		},
		{
			path: "/evaluate_teacher_create/:class_id?/:teacher_id?/:school_id?/:student_id?",
			name: "EvaluateTeacherCreate",
			component: () =>
				import("@/components/profile/EvaluateTeacherCreate"),
			linkActiveClass: "active",
			meta: {
				title: "家长评价"
			}
		},

		{
			path: "/profile_proposal",
			name: "ProfileProposal",
			component: () => import("@/components/profile/ProfileProposal"),
			linkActiveClass: "active",
			meta: {
				title: "留建议"
			}
		},
		{
			path: "/light_management",
			name: "lightManagement",
			component: () => import("@/components/profile/LightManagement"),
			linkActiveClass: "active",
			meta: {
				title: "馆长轻管理"
			}
		},
		{
			path: "/view_suggestion",
			name: "ViewSuggestion",
			component: () => import("@/components/profile/ViewSuggestion"),
			linkActiveClass: "active",
			meta: {
				title: "家长建议"
			}
		},
		{
			path: "/view_suggestion_del",
			name: "ViewSuggestionDel",
			component: () => import("@/components/profile/ViewSuggestionDel"),
			linkActiveClass: "active",
			meta: {
				title: "家长建议详情"
			}
		},
		{
			path: "/parent_evaluate/:id",
			name: "parentEvaluate",
			component: () => import("@/components/profile/parentEvaluate"),
			linkActiveClass: "active",
			meta: {
				title: "家长评价"
			}
		},
		{
			path: "/evaluate_detail/:id/:school_id",
			name: "evaluateDetail",
			component: () => import("@/components/profile/evaluateDetail"),
			linkActiveClass: "active",
			meta: {
				title: "评价详情"
			}
		},

		{
			path: "/see_evaluate_list",
			name: "SeeEvaluateList",
			component: () => import("@/components/profile/SeeEvaluateListNew"),
			linkActiveClass: "active",
			meta: {
				title: "家长评教"
			}
		},
		{
			path: "/see_evaluate_det/:year?/:month?/:teacherId?/:teacherName?",
			name: "SeeEvaluateDet",
			component: () => import("@/components/profile/SeeEvaluateDet"),
			linkActiveClass: "active",
			meta: {
				title: "家长评教"
			}
		},

		{
			path: "/teacher_evaluate_del",
			name: "TeacherEvaluateDel",
			component: () => import("@/components/profile/TeacherEvaluateDel"),
			linkActiveClass: "active",
			meta: {
				title: "家长评教"
			}
		},

		{
			path: "/see_class_list",
			name: "SeeClassList",
			component: () => import("@/components/profile/SeeClassList"),
			linkActiveClass: "active",
			meta: {
				title: "家长评教"
			}
		},
		{
			path: "/see_class_del_list",
			name: "SeeClassDelList",
			component: () => import("@/components/profile/SeeClassDelList"),
			linkActiveClass: "active",
			meta: {
				title: "班级所有家长评教"
			}
		},
		{
			path: "/see_evaluation_details",
			name: "SeeEvaluationDetails",
			component: () =>
				import("@/components/profile/SeeEvaluationDetails"),
			linkActiveClass: "active",
			meta: {
				title: "家长评教详情"
			}
		},
		//家长端
		{
			path: "/parent_evaluate_del/:read_id?",
			name: "ParentEvaluateDel",
			component: () => import("@/components/profile/ParentEvaluateDel"),
			linkActiveClass: "active",
			meta: {
				title: "评教详情"
			}
		},
		{
			path: "/parent_evaluate_rule",
			name: "ParentEvaluateRule",
			component: () => import("@/components/profile/ParentEvaluateRule"),
			linkActiveClass: "active",
			meta: {
				title: "评教规则"
			}
		},
		{
			path: "/parent_evaluate_content",
			name: "ParentEvaluateContent",
			component: () => import("@/components/profile/ParentEvaluateContent"),
			linkActiveClass: "active",
			meta: {
				title: "家长评教内容维护"
			}
		},

		{
			path: "/promotion_record",
			name: "PromotionRecord",
			component: () => import("@/components/profile/PromotionRecord"),
			linkActiveClass: "active",
			meta: {
				title: "推广记录"
			}
		},
		{
			path: "/promotion_income",
			name: "PromotionIncome",
			component: () => import("@/components/profile/PromotionIncome"),
			linkActiveClass: "active",
			meta: {
				title: "我的收益"
			}
		},

		{
			path: "/profile_info",
			name: "ProfileInfo",
			component: () => import("@/components/profile/ProfileInfo"),
			linkActiveClass: "active",
			meta: {
				title: "个人信息"
			}
		},
		{
			path: "/profile_setting",
			name: "ProfileSetting",
			component: () => import("@/components/profile/ProfileSetting"),
			linkActiveClass: "active",
			meta: {
				title: "账号设置"
			}
		},
		{
			path: "/profile_mobile",
			name: "ProfileMobile",
			component: () => import("@/components/profile/ProfileMobile"),
			linkActiveClass: "active",
			meta: {
				title: "修改手机号"
			}
		},
		{
			path: "/profile_bind_mobile",
			name: "ProfileBindMobile",
			component: () => import("@/components/profile/ProfileBindMobile"),
			linkActiveClass: "active",
			meta: {
				title: "绑定手机号"
			}
		},
		{
			path: "/profile_password",
			name: "ProfilePassword",
			component: () => import("@/components/profile/ProfilePassword"),
			linkActiveClass: "active",
			meta: {
				title: "修改密码"
			}
		},
		{
			path: "/password_yes",
			name: "PasswordYes",
			component: () => import("@/components/profile/PasswordYes"),
			linkActiveClass: "active",
			meta: {
				title: "修改密码成功"
			}
		},
		{
			path: "/profile_curator",
			name: "ProfileCurator",
			component: () => import("@/components/profile/ProfileCurator"),
			linkActiveClass: "active",
			meta: {
				title: "个人信息详情"
			}
		},
		{
			path: "/parent_gallery_details",
			name: "ParentGalleryDet",
			component: () => import("@/components/profile/ParentGalleryDet"),
			linkActiveClass: "active",
			meta: {
				title: "家长话廊详情"
			}
		},
		{
			path: "/create_success",
			name: "CreateSuccess",
			component: () => import("@/components/profile/CreateSuccess"),
			linkActiveClass: "active",
			meta: {
				title: "话廊创建成功"
			}
		},
		{
			path: "/works_admin",
			name: "WorksAdmin",
			component: () => import("@/components/profile/WorksAdmin"),
			linkActiveClass: "active",
			meta: {
				title: "作品管理"
			}
		},
		{
			path: "/works_parent/:studentId?",
			name: "WorksParent",
			component: () => import("@/components/work/WorksParent"),
			linkActiveClass: "active",
			meta: {
				title: "家长作品管理"
			}
		},
		{
			path: "/works_drafts",
			name: "WorksDrafts",
			component: () => import("@/components/work/WorksDrafts"),
			linkActiveClass: "active",
			meta: {
				title: "批量发布至草稿箱"
			}
		},

		{
			path: "/auth_login",
			name: "Login",
			component: () => import("@/components/auth/Login"),
			linkActiveClass: "active",
			meta: {
				title: "登录"
			}
		},
		{
			path: "/auth_login_with_sms",
			name: "LoginWithSMS",
			component: () => import("@/components/auth/LoginWithSMS"),
			linkActiveClass: "active",
			meta: {
				title: "短信验证码登录"
			}
		},
		{
			path: "/auth_register_with_mobile",
			name: "RegisterWithMobile",
			component: () => import("@/components/auth/RegisterWithMobile"),
			linkActiveClass: "active",
			meta: {
				title: "注册"
			}
		},
		{
			path: "/professor_blog_list/:professor_id",
			name: "ProfessorBlogList",
			component: () => import("@/components/professor/BlogList"),
			linkActiveClass: "active",
			meta: {
				keepAlive: true, // 需要被缓存
				title: "专家动态"
			}
		},
		{
			path: "/professor_list/:professor_category?",
			name: "ProfessorList",
			component: () => import("@/components/professor/ProfessorList"),
			linkActiveClass: "active",
			meta: {
				keepAlive: true,
				title: "专家列表"
			}
		},
		{
			path: "/professor_remark/:professor_id",
			name: "ProfessorRemark",
			component: () => import("@/components/professor/ProfessorRemark"),
			linkActiveClass: "active",
			meta: {
				keepAlive: true,
				title: "专家介绍"
			}
		},
		{
			path: "/professor_say/:detail_id",
			name: "ProfessorSay",
			component: () => import("@/components/professor/ProfessorSay"),
			linkActiveClass: "active",
			meta: {
				keepAlive: true,
				title: "专家说详情"
			}
		},
		{
			path: "/want_say",
			name: "ProfessorReleaseList",
			component: () =>
				import("@/components/professor/ProfessorReleaseList"),
			linkActiveClass: "active",
			meta: {
				title: "专家说"
			}
		},
		{
			path: "/professor_release",
			name: "ProfessorRelease",
			component: () => import("@/components/professor/ProfessorRelease"),
			linkActiveClass: "active",
			meta: {
				title: "我要说"
			}
		},

		{
			path: "/professor_teachingphilosophy",
			name: "professorTeachingPhilosophy",
			component: () =>
				import("@/components/professor/ProfessorTeachingPhilosophy"),
			linkActiveClass: "active",
			meta: {
				title: "专家美育理念"
			}
		},
		{
			path: "/professor_apply_request",
			name: "ProfessorApplyRequest",
			component: () =>
				import("@/components/professor/ProfessorApplyRequest"),
			linkActiveClass: "active",
			meta: {
				title: "专家申请认证"
			}
		},
		{
			path: "/professor_apply_see",
			name: "ProfessorApplySee",
			component: () => import("@/components/professor/ProfessorApplySee"),
			linkActiveClass: "active",
			meta: {
				title: "查看专家认证"
			}
		},
		{
			path: "/professor_school_list",
			name: "professorschoollist",
			component: () =>
				import("@/components/professor/ProfessorSchoolList"),
			linkActiveClass: "active",
			meta: {
				title: "入驻邀请"
			}
		},
		{
			path: "/professor_blog_detail/:detail_id",
			name: "ProfessorBlogDetail",
			component: () => import("@/components/professor/BlogDetail"),
			linkActiveClass: "active",
			meta: {
				title: "专家说"
			}
		},
		{
			path: "/professor_comment",
			name: "ProfessorComment",
			component: () => import("@/components/professor/Comment"),
			linkActiveClass: "active",
			meta: {
				title: "热门评论"
			}
		},
		{
			path: "/professor_reply",
			name: "ProfessorReply",
			component: () => import("@/components/professor/Reply"),
			linkActiveClass: "active",
			meta: {
				title: "回复"
			}
		},
		{
			path: "/review_appoint",
			name: "reviewappoint",
			component: () => import("@/components/professor/ReviewAppoint"),
			linkActiveClass: "active",
			meta: {
				title: "专家点评预约"
			}
		},
		{
			path: "/professor_service_setting",
			name: "professorservicesetting",
			component: () =>
				import("@/components/professor/ProfessorServiceSetting"),
			linkActiveClass: "active",
			meta: {
				title: "服务设置"
			}
		},
		{
			path: "/professor_review_details/:comment_id?/:work_id?",
			name: "professorreviewdetails",
			component: () =>
				import("@/components/professor/ProfessorReviewDetails"),
			linkActiveClass: "active",
			meta: {
				title: "专家点评详情"
			}
		},
		{
			path: "/FamousTeacherList",
			name: "famousTeacherList",
			component: () => import("@/components/professor/FamousTeacherList"),
			linkActiveClass: "active",
			meta: {
				title: "机构名师"
			}
		},
		{
			path: "/auth_role",
			name: "Role",
			component: () => import("@/components/auth/Role"),
			linkActiveClass: "active",
			meta: {
				title: "身份选择"
			}
		},
		{
			path: "/school_home_page/:school_id?/:parent_id?",
			name: "schoolHomePage",
			component: () => import("@/components/school/SchoolHomePageNew"),
			linkActiveClass: "active",
			meta: {
				title: "机构主页"
			}
		},
		{
			path: "/school_professor/:school_id?",
			name: "SchoolProfessor",
			component: () => import("@/components/school/SchoolProfessor"),
			linkActiveClass: "active",
			meta: {
				title: "美育专家"
			}
		},
		{
			path: "/school_home_details/:school_id?",
			name: "schoolHomeDetails",
			component: () => import("@/components/school/schoolHomeDetails"),
			linkActiveClass: "active",
			meta: {
				title: "机构"
			}
		},
		{
			path: "/school_teach_theory/:school_id?", // 机构教育理念
			name: "SchoolTeachTheory",
			component: () => import("@/components/school/SchoolTeachTheory"),
			linkActiveClass: "active",
			meta: {
				title: "机构教育理念"
			}
		},
		{
			path: "/school_teacher_aptitude_details/:school_id?", // 机构教师资质详情
			name: "schoolTeacherAptitudeDetails",
			component: () =>
				import("@/components/school/SchoolTeacherAptitudeDetails"),
			linkActiveClass: "active",
			meta: {
				title: "教师资质"
			}
		},
		{
			path: "/school_role_choice",
			name: "schoolRoleChoice",
			component: () => import("@/components/school/SchoolRoleChoiceNew"),
			linkActiveClass: "active",
			meta: {
				title: "选择角色"
			}
		},
		{
			path: "/school_intro/:school_id?",
			name: "schoolIntro",
			component: () => import("@/components/school/SchoolIntro"),
			linkActiveClass: "active",
			meta: {
				title: "机构简介"
			}
		},
		{
			path: "/school_create",
			name: "SchoolCreate",
			component: () => import("@/components/school/SchoolCreate"),
			linkActiveClass: "active",
			meta: {
				title: "注册机构"
			}
		},
		{
			path: "/school_auditstatus/:school_id?",
			name: "SchoolAuditStatus",
			component: () => import("@/components/school/SchoolAuditStatus"),
			linkActiveClass: "active",
			meta: {
				title: "机构基础信息"
			}
		},
		{
			path: "/school_edit",
			name: "SchoolEdit",
			component: () => import("@/components/school/SchoolEdit"),
			linkActiveClass: "active",
			meta: {
				title: "机构信息"
			}
		},
		{
			path: "/school_teacher_aptitude",
			name: "SchoolTeacherAptitude",
			component: () =>
				import("@/components/school/SchoolTeacherAptitude"),
			linkActiveClass: "active",
			meta: {
				title: "教师资质"
			}
		},
		{
			path: "/school_teacher_aptitud_new",
			name: "SchoolTeacherAptitudeNew",
			component: () =>
				import("@/components/school/SchoolTeacherAptitudeNew"),
			linkActiveClass: "active",
			meta: {
				title: "教师资质"
			}
		},
		{
			path: "/school_teaching_philosophy",
			name: "SchoolTeachingPhilosophy",
			component: () =>
				import("@/components/school/SchoolTeachingPhilosophy"),
			linkActiveClass: "active",
			meta: {
				title: "教学理念"
			}
		},
		{
			path: "/school_authorization/:school_id",
			name: "SchoolChildAuthorization",
			component: () =>
				import("@/components/school/SchoolChildAuthorization"),
			linkActiveClass: "active",
			meta: {
				title: "授权分馆馆长"
			}
		},
		{
			path: "/school_child_list",
			name: "SchoolChildList",
			component: () => import("@/components/school/SchoolChildList"),
			linkActiveClass: "active",
			meta: {
				title: "直营馆列表"
			}
		},
		{
			path: "/school_child_detail/:school_id",
			name: "SchoolChildDetail",
			component: () => import("@/components/school/SchoolChildDetail"),
			linkActiveClass: "active",
			meta: {
				title: "机构详情"
			}
		},
		{
			path: "/school_child_create",
			name: "SchoolChildCreate",
			component: () => import("@/components/school/SchoolChildCreate"),
			linkActiveClass: "active",
			meta: {
				title: "创建直营分馆"
			}
		},
		{
			path: "/school_child_edit/:school_id",
			name: "SchoolChildEdit",
			component: () => import("@/components/school/SchoolChildEdit"),
			linkActiveClass: "active",
			meta: {
				title: "直营分馆详情"
			}
		},
		{
			path: "/school_certification/:school_id?",
			name: "SchoolCertification",
			component: () => import("@/components/school/SchoolCertification"),
			linkActiveClass: "active",
			meta: {
				title: "机构认证"
			}
		},
		{
			path: "/school_professor_list",
			name: "schoolprofessorlist",
			component: () => import("@/components/school/SchoolProfessorList"),
			linkActiveClass: "active",
			meta: {
				title: "专家邀约"
			}
		},
		{
			path: "/activity_model/:type?",
			name: "activityModel",
			component: () => import("@/components/activity/ActivityModelNew"),
			linkActiveClass: "active",
			meta: {
				title: "活动模板"
			}
		},
		{
			path: "/school_activity_list/:school_id",
			name: "SchoolActivityList",
			component: () =>
				import("@/components/school/SchoolActivityListNew"),
			linkActiveClass: "active",
			meta: {
				title: "活动列表"
			}
		},
		{
			path: "/school_info_manager",
			name: "SchoolInfoManager",
			component: () => import("@/components/school/SchoolInfoManager"),
			linkActiveClass: "active",
			meta: {
				title: "机构信息管理"
			}
		},

		{
			path: "/school_info",
			name: "SchoolInfo",
			component: () => import("@/components/school/SchoolInfo"),
			linkActiveClass: "active",
			meta: {
				title: "机构图片设置"
			}
		},
		{
			path: "/school_introduction",
			name: "SchoolIntroduction",
			component: () => import("@/components/school/SchoolIntroduction"),
			linkActiveClass: "active",
			meta: {
				title: "机构简介"
			}
		},
		{
			path: "/teacher_list/",
			name: "TeacherList",
			component: () => import("@/components/teacher/TeacherList"),
			linkActiveClass: "active",
			meta: {
				title: "教师列表"
			}
		},
		{
			path: "/teacher_details/:teacher_id",
			name: "TeacherDetails",
			component: () => import("@/components/teacher/TeacherDetails"),
			linkActiveClass: "active",
			meta: {
				title: "教师详情"
			}
		},
		{
			path: "/teacher_add_code/:school_id",
			name: "TeacherAddCode",
			component: () => import("@/components/teacher/TeacherAddFromCode"),
			linkActiveClass: "active",
			meta: {
				title: "扫码添加"
			}
		},
		{
			path: "/teacher_create",
			name: "Teac herCreate",
			component: () => import("@/components/teacher/TeacherCreate"),
			linkActiveClass: "active",
			meta: {
				title: "添加老师"
			}
		},
		{
			path: "/teacher_manage_class/:teacher_id",
			name: "TeacherManageClass",
			component: () => import("@/components/teacher/TeacherManageClass"),
			linkActiveClass: "active",
			meta: {
				title: "配置管理班级"
			}
		},
		{
			path: "/class_list",
			name: "ClassList",
			component: () => import("@/components/class/ClassList"),
			linkActiveClass: "active",
			meta: {
				title: "班级管理"
			}
		},
		{
			path: "/class_create",
			name: "ClassCreate",
			component: () => import("@/components/class/ClassCreate"),
			linkActiveClass: "active",
			meta: {
				title: "创建班级"
			}
		},
		{
			path: "/class_edit/:id",
			name: "ClassEdit",
			component: () => import("@/components/class/ClassEdit"),
			linkActiveClass: "active",
			meta: {
				title: "班级维护"
			}
		},
		{
			path: "/student_list",
			name: "StudentList",
			component: () => import("@/components/student/StudentList"),
			linkActiveClass: "active",
			meta: {
				title: "学员管理"
			}
		},
		{
			path: "/student_add_parent",
			name: "StudentAddParent",
			component: () => import("@/components/student/StudentAddParent"),
			linkActiveClass: "active",
			meta: {
				title: "添加学员家长"
			}
		},
		{
			path: "/student_certification",
			name: "StudentCertification",
			component: () =>
				import("@/components/student/StudentCertification"),
			linkActiveClass: "active",
			meta: {
				title: "添加已注册学员"
			}
		},
		{
			path: "/student_nocertification",
			name: "StudentNoCertification",
			component: () =>
				import("@/components/student/StudentNoCertification"),
			linkActiveClass: "active",
			meta: {
				title: "添加未注册学员"
			}
		},
		{
			path: "/student_add_class/:student_id",
			name: "studentAddClass",
			component: () => import("@/components/student/StudentAddClass"),
			linkActiveClass: "active",
			meta: {
				title: "请选择加入班级"
			}
		},
		{
			path: "/students_add_class/:student_ids/:old_class?",
			name: "StudentsAddClass",
			component: () => import("@/components/student/StudentsAddClass"),
			linkActiveClass: "active",
			meta: {
				title: "请选择加入班级"
			}
		},
		{
			path: "/student_update_class",
			name: "StudentUpdateClass",
			component: () => import("@/components/student/StudentUpdateClass"),
			linkActiveClass: "active",
			meta: {
				title: "请选择加入班级"
			}
		},
		{
			path: "/student_info/:student_id",
			name: "StudentInfo",
			component: () => import("@/components/student/StudentInfo"),
			linkActiveClass: "active",
			meta: {
				title: "学员信息"
			}
		},
		{
			path: "/student_join",
			name: "studentJoin",
			component: () => import("@/components/student/StudentJoin"),
			linkActiveClass: "active",
			meta: {
				title: "请选择加入班级"
			}
		},
		{
			path: "/student_create/:parent_id",
			name: "StudentCreate",
			component: () => import("@/components/student/StudentCreate"),
			linkActiveClass: "active",
			meta: {
				title: "添加学员"
			}
		},
		{
			path: "/student_step_one",
			name: "StudentStepOne",
			component: () => import("@/components/student/StudentStepOne"),
			linkActiveClass: "active",
			meta: {
				title: "批量添加学员-选择班级"
			}
		},
		{
			path: "/student_step_two/:class_id",
			name: "StudentStepTwo",
			component: () => import("@/components/student/StudentStepTwo"),
			linkActiveClass: "active",
			meta: {
				title: "批量添加学员-添加学员"
			}
		},
		{
			path: "/student_step_one_new",
			name: "StudentStepOneNew",
			component: () => import("@/components/student/StudentStepOneNew"),
			linkActiveClass: "active",
			meta: {
				title: "添加学员"
			}
		},
		{
			path: "/student_parent_list/:parent_id",
			name: "StudentParentList",
			component: () => import("@/components/student/StudentParentList"),
			linkActiveClass: "active",
			meta: {
				title: "Ta的孩子"
			}
		},
		{
			path: "/student_class",
			name: "StudentClass",
			component: () => import("@/components/student/StudentClass"),
			linkActiveClass: "active",
			meta: {
				title: "学生班级"
			}
		},
		{
			path: "/student_hope",
			name: "StudentHope",
			component: () => import("@/components/student/StudentHope"),
			linkActiveClass: "active",
			meta: {
				title: "爱的寄语"
			}
		},
		{
			path: "/brand_certification",
			name: "BrandCertification",
			component: () => import("@/components/brand/BrandCertification"),
			linkActiveClass: "active",
			meta: {
				title: "品牌认证"
			}
		},
		{
			path: "/parent_class_join_ask/:class_id",
			name: "ParentClassJoinAsk",
			component: () => import("@/components/parent/ParentClassJoinAsk"),
			linkActiveClass: "active",
			meta: {
				title: "加入班级"
			}
		},
		{
			path: "/red_envelopes/:red_ids?/:red_fee?",
			name: "RedEnvelopes",
			component: () => import("@/components/parent/RedEnvelopes"),
			linkActiveClass: "active",
			meta: {
				title: "领红包"
			}
		},
		{
			path: "/parent_children_list/:class_id",
			name: "ParentChildrenList",
			component: () => import("@/components/parent/ParentChildrenList"),
			linkActiveClass: "active",
			meta: {
				title: "我的孩子"
			}
		},
		{
			path: "/gallery_receive",
			name: "GalleryReceive",
			component: () => import("@/components/gallery/GalleryReceive"),
			linkActiveClass: "active",
			meta: {
				title: "认领话廊"
			}
		},
		{
			path: "/gallery_dynamic",
			name: "GalleryDynamic",
			component: () => import("@/components/gallery/GalleryDynamic"),
			linkActiveClass: "active",
			meta: {
				title: "话廊动态"
			}
		},
		{
			path: "/gallery_query",
			name: "galleryQuery",
			component: () => import("@/components/gallery/GalleryQuery"),
			linkActiveClass: "active",
			meta: {
				title: "话廊查询"
			}
		},
		{
			path: "/gallery_my_fans",
			name: "GalleryMyFans",
			component: () => import("@/components/gallery/GalleryMyFans"),
			linkActiveClass: "active",
			meta: {
				title: "话廊-我的粉丝"
			}
		},

		{
			path: "/gallery_my_fans_new/:gallery_id",
			name: "GalleryMyFansNew",
			component: () => import("@/components/gallery/GalleryMyFansNew"),
			linkActiveClass: "active",
			meta: {
				title: "我的粉丝"
			}
		},

		{
			path: "/work_create/:code?",
			name: "WorkCreate",
			component: () => import("@/components/work/WorkCreate"),
			linkActiveClass: "active",
			meta: {
				title: "发布作品"
			}
		},
		{
			path: "/work_create_new/:code?",
			redirect: to => to.params.code ? `/work_create/${to.params.code}` : "/work_create"
		},
		{
			path: "/work_list",
			name: "WorkList",
			component: () => import("@/components/work/WorkListCvNew"),
			linkActiveClass: "active",
			meta: {
				title: "作品列表"
			}
		},
		{
			path: "/batchOperate/:type",
			name: "batchOperate",
			component: () => import("@/components/work/batchOperate"),
			linkActiveClass: "active",
			meta: {
				title: ""
			}
		},
		{
			path: "/work_edit/:work_id/:fromcg?/:isAttendance?",
			// path: "/work_edit/:work_id/:fromcg?/:code?/:isAttendance?",
			name: "WorkEdit",
			component: () => import("@/components/work/WorkEdit"),
			linkActiveClass: "active",
			meta: {
				title: "修改作品"
			}
		},
		{
			path: "/work_detail/:work_id/",
			name: "WorkDetail",
			component: () => import("@/components/work/WorkDetail"),
			linkActiveClass: "active",
			meta: {
				title: "作品详情"
			}
		},
		{
			path: "/week_new_work/:school_id?",
			name: "WeekNewWork",
			component: () => import("@/components/work/WeekNewWork"),
			linkActiveClass: "active",
			meta: {
				title: "本周更新作品"
			}
		},

		{
			path: "/sms_manage",
			name: "SmsManage",
			component: () => import("@/components/sms/SmsManage"),
			linkActiveClass: "active",
			meta: {
				title: "短信管理"
			}
		},
		{
			path: "/pay/sms_buy",
			name: "SmsBuy",
			component: () => import("@/components/sms/SmsBuy"),
			linkActiveClass: "active",
			meta: {
				title: "购买短信"
			}
		},
		{
			path: "/sms_order",
			name: "SmsOrder",
			component: () => import("@/components/sms/SmsOrder"),
			linkActiveClass: "active",
			meta: {
				title: "购买记录"
			}
		},
		{
			path: "/school_message_list",
			name: "SchoolMessageList",
			component: () => import("@/components/school/SchoolMessageList"),
			linkActiveClass: "active",
			meta: {
				title: "馆讯列表"
			}
		},
		{
			path: "/school_message_add",
			name: "SchoolMessageAdd",
			component: () => import("@/components/school/SchoolMessageAdd"),
			linkActiveClass: "active",
			meta: {
				title: "发布馆讯"
			}
		},
		{
			path: "/school_message_edit/:message_id",
			name: "SchoolMessageEdit",
			component: () => import("@/components/school/SchoolMessageEdit"),
			linkActiveClass: "active",
			meta: {
				title: "修改馆讯"
			}
		},
		{
			path: "/activity_create/:activity_model?/:activity_type?/:activity_id?/:type?",
			name: "ActivityCreate",
			component: () => import("@/components/activity/ActivityCreateNew"),
			linkActiveClass: "active",
			meta: {
				title: "发布活动"
			}
		},

		{
			path: "/activity_school_create",
			name: "ActivitySchoolCreate",
			component: () =>
				import("@/components/activity/ActivitySchoolCreate"),
			linkActiveClass: "active",
			meta: {
				title: "完善信息"
			}
		},

		{
			path: "/activity_list",
			name: "ActivityList",
			component: () => import("@/components/activity/ActivityListNew"),
			linkActiveClass: "active",
			meta: {
				title: "活动管理"
			}
		},
		{
			path: "/activity_cglist",
			name: "ActivityCgList",
			component: () => import("@/components/activity/ActivityCgList"),
			linkActiveClass: "active",
			meta: {
				title: "活动管理"
			}
		},
		{
			path: "/activity_cgxg/:activity_type?/:activity_id?",
			name: "ActivityCgXg",
			component: () => import("@/components/activity/ActivityCgXg"),
			linkActiveClass: "active",
			meta: {
				title: "活动管理"
			}
		},
		{
			path: "/activity_edit/:activity_id",
			name: "ActivityEdit",
			component: () => import("@/components/activity/ActivityEdit"),
			linkActiveClass: "active",
			meta: {
				title: "活动详情"
			}
		},
		{
			path: "/activity_preview/:activity_id?/:parent_id?",
			name: "ActivityPreview",
			component: () => import("@/components/activity/ActivityPreview"),
			linkActiveClass: "active",
			meta: {
				title: "活动预览"
			}
		},
		{
			path: "/activity_template_del/:activity_id?",
			name: "ActivityTemplateDel",
			component: () =>
				import("@/components/activity/ActivityTemplateDel"),
			linkActiveClass: "active",
			meta: {
				title: "活动模板详情"
			}
		},

		{
			path: "/activity_detail/:activity_id",
			name: "ActivityDetail",
			component: () => import("@/components/activity/ActivityDetail"),
			linkActiveClass: "active",
			meta: {
				title: "活动详情"
			}
		},
		{
			path: "/activity_registration/:activity_id",
			name: "activityRegistration",
			component: () =>
				import("@/components/activity/ActivityRegistration"),
			linkActiveClass: "active",
			meta: {
				title: "查看报名列表"
			}
		},
		{
			path: "/activity_registration_Details/:activity?/:activity_id?",
			name: "activityRegistrationDetails",
			component: () =>
				import("@/components/activity/ActivityRegistrationDetails"),
			linkActiveClass: "active",
			meta: {
				title: "查看报名详情"
			}
		},
		{
			path: "/my_activity",
			name: "myActivity",
			component: () => import("@/components/activity/MyActivity"),
			linkActiveClass: "active",
			meta: {
				title: "我的活动"
			}
		},
		{
			path: "/pay/my_activity_details",
			name: "myActivityDetails",
			component: () => import("@/components/activity/MyActivityDetails"),
			linkActiveClass: "active",
			meta: {
				title: "活动报名"
			}
		},
		{
			path: "/activity_failed",
			name: "activityFailed",
			component: () => import("@/components/activity/ActivityFailed"),
			linkActiveClass: "active",
			meta: {
				title: "活动失败"
			}
		},
		{
			path: "/activity_refund_success",
			name: "activityRefundSuccess",
			component: () =>
				import("@/components/activity/ActivityRefundSuccess"),
			linkActiveClass: "active",
			meta: {
				title: "活动退款申请成功"
			}
		},
		{
			path: "/activity_verification/:activity_id/:mobile/:checkTime/:activity_buy_user_id",
			name: "activityVerification",
			component: () =>
				import("@/components/activity/ActivityVerification"),
			linkActiveClass: "active",
			meta: {
				title: "活动核销"
			}
		},
		{
			path: "/activity_fund_success/:activity_id?/:mobile?/:signtime?/:activity_buy_user_id?",
			name: "activityFundSuccess",
			component: () =>
				import("@/components/activity/ActivityFundSuccess"),
			linkActiveClass: "active",
			meta: {
				title: "活动付款成功"
			}
		},
		{
			path: "/activity_expiry",
			name: "activityExpiry",
			component: () => import("@/components/activity/ActivityExpiry"),
			linkActiveClass: "active",
			meta: {
				title: "活动失效"
			}
		},
		{
			path: "/job_list",
			name: "JobList",
			component: () => import("@/components/job/JobList"),
			linkActiveClass: "active",
			meta: {
				title: "招聘管理"
			}
		},
		{
			path: "/school_activity_details/:activity_id/:parent_id?/:title?",
			name: "SchoolActivityDetails",
			component: () =>
				import("@/components/activity/SchoolActivityDetails"),
			linkActiveClass: "active",
			meta: {
				title: "机构活动详情"
			}
		},
		{
			//   path: '/pay/only_school_activity_details/:activity_id/:parent_id?/',
			path: "/pay/only_school_activity_details",
			name: "OnlySchoolActivityDetails",
			component: () =>
				import("@/components/activity/OnlySchoolActivityDetails"),
			linkActiveClass: "active",
			meta: {
				title: "机构活动详情"
			}
		},
		// {
		//     path: '/school_bind_manager/:school_id',
		//     name: 'SchoolBindManager',
		//     component: SchoolBindManager,
		//     linkActiveClass: 'active',
		//     meta: {
		//         title: '绑定运营'
		//     }
		// },
		{
			path: "/job_detail/:job_id",
			name: "JobDetail",
			component: () => import("@/components/job/JobDetail"),
			linkActiveClass: "active",
			meta: {
				title: "招聘详情"
			}
		},
		{
			path: "/job_create",
			name: "JobCreate",
			component: () => import("@/components/job/JobCreate"),
			linkActiveClass: "active",
			meta: {
				title: "招聘发布"
			}
		},

		{
			path: "/course_create/:school?",
			name: "course_create",
			component: () => import("@/components/course/CourseCreate"),
			linkActiveClass: "active",
			meta: {
				title: "课程发布"
			}
		},
		{
			path: "/course_detail/:course_id",
			name: "CourseDetail",
			component: () => import("@/components/course/CourseDetail"),
			linkActiveClass: "active",
			meta: {
				title: "课程详情"
			}
		},
		{
			path: "/course_list/:school_id?",
			name: "CourseList",
			component: () => import("@/components/course/CourseListNew"),
			linkActiveClass: "active",
			meta: {
				title: "课程管理"
			}
		},
		{
			path: "/activity_course_list/:school_id?",
			name: "ActivityCourseList",
			component: () => import("@/components/course/ActivityCourseList"),
			linkActiveClass: "active",
			meta: {
				title: "活动课程管理"
			}
		},

		{
			path: "/course_introduce_list/:school_id?",
			name: "CourseIntroduceList",
			component: () =>
				import("@/components/course/CourseIntroduceListNew"),
			linkActiveClass: "active",
			meta: {
				title: "口碑招生"
			}
		},
		{
			path: "/single_course_introduce/:item_id/:type",
			name: "singleCourseIntroduce",
			component: () =>
				import("@/components/course/singleCourseIntroduce"),
			linkActiveClass: "active",
			meta: {
				title: "推荐明细"
			}
		},
		{
			path: "/course_introduce_edit/:course_id?/:type?",
			name: "CourseIntroduceEdit",
			component: () => import("@/components/course/CourseIntroduceEdit"),
			linkActiveClass: "active",
			meta: {
				title: "规则编辑"
			}
		},
		{
			path: "/course_introduce_del/:introduce_id?",
			name: "CourseIntroduceDel",
			component: () => import("@/components/course/CourseIntroduceDel"),
			linkActiveClass: "active",
			meta: {
				title: "推荐规则"
			}
		},
		// {
		//     path: "/introduce_del",
		//     name: "IntroduceDel",
		//     component: () => import("@/components/course/IntroduceDel"),
		//     linkActiveClass: "active",
		//     meta: {
		//         title: "推荐规则"
		//     }
		// },
		{
			path: "/account_setting",
			name: "accountSetting",
			component: () => import("@/components/profile/AccountSetting"),
			linkActiveClass: "active",
			meta: {
				title: "账号设置"
			}
		},
		{
			path: "/retrieve_password",
			name: "RetrievePassword",
			component: () => import("@/components/profile/RetrievePassword"),
			linkActiveClass: "active",
			meta: {
				title: "找回密码"
			}
		},

		{
			path: "/account_add",
			name: "accountAdd",
			component: () => import("@/components/profile/AccountAdd"),
			linkActiveClass: "active",
			meta: {
				title: "画宝汇账号"
			}
		},
		{
			path: "/passwor_add",
			name: "passwordAdd",
			component: () => import("@/components/profile/PasswordAdd"),
			linkActiveClass: "active",
			meta: {
				title: "密码设置"
			}
		},
		{
			path: "/support_center",
			name: "supportCenter",
			component: () => import("@/components/profile/SupportCenter"),
			linkActiveClass: "active",
			meta: {
				title: "帮助中心"
			}
		},
		{
			path: "/feed_back",
			name: "feedBack",
			component: () => import("@/components/profile/FeedBack"),
			linkActiveClass: "active",
			meta: {
				title: "留言反馈"
			}
		},
		{
			path: "/help_info/:id",
			name: "helpInfo",
			component: () => import("@/components/profile/HelpInfo"),
			linkActiveClass: "active",
			meta: {
				title: "常见问题"
			}
		},
		{
			path: "/family_list",
			name: "FamilyList",
			component: () => import("@/components/family/FamilyList"),
			linkActiveClass: "active",
			meta: {
				title: "亲友团"
			}
		},
		{
			path: "/joinFamily/:id",
			name: "joinFamily",
			component: () => import("@/components/family/joinFamily"),
			linkActiveClass: "active",
			meta: {
				title: "加入亲友团"
			}
		},
		{
			path: "/family_gallery_list",
			name: "familyGalleryList",
			component: () => import("@/components/family/FamilyGalleryList"),
			linkActiveClass: "active",
			meta: {
				title: "亲友话廊"
			}
		},
		{
			path: "/honor_list",
			name: "honorList",
			component: () => import("@/components/school/SchoolHonor"),
			linkActiveClass: "active",
			meta: {
				title: "荣誉列表"
			}
		},
		{
			path: "/honor_add",
			name: "honorAdd",
			component: () => import("@/components/school/SchoolHonorAdd"),
			linkActiveClass: "active",
			meta: {
				title: "荣誉上传"
			}
		},
		{
			path: "/honor_edit/:honor_id?",
			name: "honorEdit",
			component: () => import("@/components/school/SchoolHonorEdit"),
			linkActiveClass: "active",
			meta: {
				title: "荣誉详情"
			}
		},
		{
			path: "/user_favorites",
			name: "userFavorites",
			component: () => import("@/components/profile/UserFavorites"),
			linkActiveClass: "active",
			meta: {
				title: "我的收藏"
			}
		},
		{
			path: "/user_scores",
			name: "userScores",
			component: () => import("@/components/profile/UserScores"),
			linkActiveClass: "active",
			meta: {
				title: "我的画宝币"
			}
		},
		{
			path: "/user_focuses",
			name: "userFocuses",
			component: () => import("@/components/profile/UserFocuses"),
			linkActiveClass: "active",
			meta: {
				title: "我的关注"
			}
		},
		{
			path: "/wallet",
			name: "wallet",
			component: () => import("@/components/wallet/WalletNew"),
			linkActiveClass: "active",
			meta: {
				title: "钱包"
			}
		},
		{
			path: "/changeDetail",
			name: "changeDetail",
			component: () => import("@/components/wallet/ChangeDetail"),
			linkActiveClass: "active",
			meta: {
				title: "零钱明细"
			}
		},
		{
			path: "/pay/topUp",
			name: "topUp",
			component: () => import("@/components/wallet/topUp"),
			linkActiveClass: "active",
			meta: {
				title: "充值"
			}
		},
		{
			path: "/pay/withdrawal",
			name: "withdrawal",
			component: () => import("@/components/wallet/withdrawal"),
			linkActiveClass: "active",
			meta: {
				title: "提现"
			}
		},
		{
			path: "/pay/newWithdrawal",
			name: "newWithdrawal",
			component: () => import("@/components/wallet/newWithdrawal"),
			linkActiveClass: "active",
			meta: {
				title: "提现" // 新版提现
			}
		},
		{
			path: "/school_honor_list/:school_id?",
			name: "schoolHonor",
			component: () => import("@/components/school/SchoolHonor"),
			linkActiveClass: "active",
			meta: {
				title: "机构荣誉列表"
			}
		},
		{
			path: "/school_search",
			name: "schoolSearch",
			component: () => import("@/components/school/SchoolSearch"),
			linkActiveClass: "active",
			meta: {
				title: "机构查询"
			}
		},

		{
			path: "/school_goodwork/:school_id?",
			name: "schoolGoodWork",
			component: () => import("@/components/school/SchoolGoodWork"),
			linkActiveClass: "active",
			meta: {
				title: "机构优选佳作列表"
			}
		},

		{
			path: "/school_job/:school_id?",
			name: "schoolJob",
			component: () => import("@/components/school/SchoolJob"),
			linkActiveClass: "active",
			meta: {
				title: "机构招聘列表"
			}
		},
		{
			path: "/school_jobdetail/:id?/:parent_id?",
			name: "schoolJobDetail",
			component: () => import("@/components/school/SchoolJobDetail"),
			linkActiveClass: "active",
			meta: {
				title: "机构招聘详情"
			}
		},
		{
			path: "/school_information_management/:school_id?",
			name: "SchoolInformationManagement",
			component: () =>
				import("@/components/school/SchoolInformationManagement"),
			linkActiveClass: "active",
			meta: {
				title: "机构资讯管理"
			}
		},
		{
			path: "/school_information_details/:blog_id/:parent_id?",
			name: "SchoolInformationDetails",
			component: () =>
				import("@/components/school/SchoolInformationDetails"),
			linkActiveClass: "active",
			meta: {
				title: "机构资讯详情"
			}
		},
		{
			path: "/demo_school_course/:school_id?/:CourseType?/:parent_id?",
			name: "schoolCourse",
			component: () => import("@/components/school/SchoolCourseNew"),
			linkActiveClass: "active",
			meta: {
				title: "机构课程列表"
			}
		},
		{
			path: "/school_coursedetail/:id/:school_id?/:parent_id?",
			name: "schoolCourseDetail",
			component: () =>
				import("@/components/school/SchoolCourseDetailNew"),
			linkActiveClass: "active",
			meta: {
				title: "机构课程详情"
			}
		},
		{
			path: "/school_coursedetailtest/:id/:school_id?/:parent_id?",
			name: "schoolCourseDetailtest",
			component: () =>
				import("@/components/school/schoolCourseDetailtest"),
			linkActiveClass: "active",
			meta: {
				title: "机构课程详情"
			}
		},
		{
			path: "/school_Activity_detail/:id/:school_id?/:parent_id?",
			name: "schoolActivityDetail",
			component: () => import("@/components/school/SchoolActivityDetail"),
			linkActiveClass: "active",
			meta: {
				title: "机构课程详情"
			}
		},
		{
			path: "/haoke99_intro",
			name: "haoke99Intro",
			component: () => import("@/components/school/HaoKe99Intro"),
			linkActiveClass: "active",
			meta: {
				title: "机构入驻"
			}
		},
		{
			path: "/haoke99_apply",
			name: "haoke99Apply",
			component: () => import("@/components/school/HaoKe99Apply"),
			linkActiveClass: "active",
			meta: {
				title: "申请加入"
			}
		},
		{
			path: "/haoke99_union_list",
			name: "haoke99UnionList",
			component: () => import("@/components/school/HaoKe99UnionList"),
			linkActiveClass: "active",
			meta: {
				title: "平台招生"
			}
		},
		{
			path: "/school_commentdetail/:id",
			name: "schoolCommentDetail",
			component: () => import("@/components/school/SchoolCourseCommit"),
			linkActiveClass: "active",
			meta: {
				title: "机构评论详情"
			}
		},
		{
			path: "/circle_alarm_list",
			name: "circlealarmlist",
			component: () =>
				import("@/components/artEduCircle/CircleAlarmList"),
			linkActiveClass: "active",
			meta: {
				title: "回复提醒"
			}
		},
		{
			path: "/parent_class",
			name: "parentclass",
			component: () => import("@/components/artEduCircle/ParentClass"),
			linkActiveClass: "active",
			meta: {
				title: "家长课堂"
			}
		},
		{
			path: "/industry_info",
			name: "industryinfo",
			component: () => import("@/components/artEduCircle/IndustryInfo"),
			linkActiveClass: "active",
			meta: {
				title: "行业资讯"
			}
		},
		{
			path: "/famous_teacher",
			name: "famousteacher",
			component: () => import("@/components/artEduCircle/FamousTeacher"),
			linkActiveClass: "active",
			meta: {
				title: "名师专家"
			}
		},
		{
			path: "/activity_area",
			name: "activityarea",
			component: () => import("@/components/artEduCircle/ActivityArea"),
			linkActiveClass: "active",
			meta: {
				title: "活动专区"
			}
		},
		{
			path: "/promotion_center",
			name: "promotionCenter",
			component: () =>
				import("@/components/promotionCenter/PromotionCenter"),
			linkActiveClass: "active",
			meta: {
				title: "推广中心"
			}
		},
		{
			path: "/income_list",
			name: "incomeList",
			component: () => import("@/components/promotionCenter/IncomeList"),
			linkActiveClass: "active",
			meta: {
				title: "收入明细"
			}
		},
		{
			path: "/promote_immediately",
			name: "promoteImmediately",
			component: () =>
				import("@/components/promotionCenter/PromoteImmediately"),
			linkActiveClass: "active",
			meta: {
				title: "立即推广"
			}
		},
		{
			path: "/how_promote",
			name: "howPromote",
			component: () => import("@/components/promotionCenter/HowPromote"),
			linkActiveClass: "active",
			meta: {
				title: "如何推广"
			}
		},
		{
			path: "/with_draw",
			name: "withDraw",
			component: () => import("@/components/promotionCenter/WithDraw"),
			linkActiveClass: "active",
			meta: {
				title: "推广中心--提现"
			}
		},
		// {
		//     path: '/pay/buy_gallery_:school_id',
		//     name: 'buyGallery',
		//     component: ()=>import('@/components/VIP/BuyGallery'),
		//     linkActiveClass: 'active',
		//     meta: {
		//         title: '购买话廊'
		//     }
		// },
		{
			path: "/available_galleries",
			name: "availableGalleries",
			component: () => import("@/components/VIP/AvailableGalleries"),
			linkActiveClass: "active",
			meta: {
				title: "可用话廊数量"
			}
		},
		{
			path: "/vip_member_center/:parent_id?",
			name: "vipmemberCenter",
			component: () => import("@/components/VIP_v2/VIPMemberCenter"),
			// component: ()=>import('@/components/VIP/VIPMemberCenter'),
			linkActiveClass: "active",
			meta: {
				title: "会员中心"
			}
		},
		{
			path: "/other_equity",
			name: "otherEquity",
			component: () => import("@/components/VIP/OtherEquity"),
			linkActiveClass: "active",
			meta: {
				title: "其他权益"
			}
		},
		{
			path: "/allquanyi",
			name: "allEquity",
			component: () => import("@/components/VIP/AllEquity"),
			linkActiveClass: "active",
			meta: {
				title: "会员权益"
			}
		},
		{
			path: "/transfer/:type_id?/:parent_id?",
			name: "Transfer",
			component: () => import("@/components/VIP/Transfer"),
			linkActiveClass: "active",
			meta: {
				title: "画宝汇"
			}
		},
		{
			path: "/contact_teacher/:student_id/:parent_id?",
			name: "contactTeacher",
			component: () => import("@/components/teacher/ContactTeacher"),
			linkActiveClass: "active",
			meta: {
				title: "联系老师"
			}
		},
		{
			path: "/contact_schoolLeader/:teacher_id/:parent_id?",
			name: "contactSchoolLeader",
			component: () => import("@/components/teacher/ContactSchoolLeader"),
			linkActiveClass: "active",
			meta: {
				title: "联系校长"
			}
		},
		{
			path: "/pay/buy_vip_new_:vip_id?_:vip_type?_:parent_id?",
			name: "buyVIPNew",
			component: () => import("@/components/VIP/BuyVIPNew"),
			linkActiveClass: "active",
			meta: {
				title: "购买会员"
			}
		},
		{
			path: "/pay/renew_vip_:vip_id?_:vip_type?_:parent_id?",
			name: "RenewVIP",
			component: () => import("@/components/VIP/RenewVIP"),
			linkActiveClass: "active",
			meta: {
				title: "会员续费"
			}
		},
		{
			path: "/pay/up_vip_:vip_id?_:vip_type?_:parent_id?",
			name: "UpVIP",
			component: () => import("@/components/VIP/UpVIP"),
			linkActiveClass: "active",
			meta: {
				title: "升级会员"
			}
		},
		// {
		//     path: '/pay/buy_schoolvip_:school_id',
		//     name: 'buySchoolVip',
		//     component: ()=>import('@/components/VIP/BuySchoolVip'),
		//     linkActiveClass: 'active',
		//     meta: {
		//         title: '直营分馆升级'
		//     }
		// },
		{
			path: "/buy_cofounder",
			name: "buyCofounder",
			component: () => import("@/components/VIP/BuyCofounder"),
			linkActiveClass: "active",
			meta: {
				title: "升级VIP"
			}
		},
		{
			path: "/pormotion_image/:id/:parent_id?",
			name: "pormotionImage",
			component: () =>
				import("@/components/promotionCenter/PromotionImage"),
			linkActiveClass: "active",
			meta: {
				title: "我的分享"
			}
		},
		{
			path: "/activation_code",
			name: "activationCode",
			component: () => import("@/components/VIP/ActivationCode"),
			linkActiveClass: "active",
			meta: {
				title: "VIP馆激活码"
			}
		},
		{
			path: "/conversion_code/:school_id",
			name: "conversionCode",
			component: () => import("@/components/VIP/ConversionCode"),
			linkActiveClass: "active",
			meta: {
				title: "兑换码升级"
			}
		},
		{
			path: "/upgrade_equity",
			name: "upgradeEquity",
			component: () => import("@/components/VIP/UpgradeEquity"),
			linkActiveClass: "active",
			meta: {
				title: "VIP直营分馆升级权益"
			}
		},
		{
			path: "/public_comment/:id/:type",
			name: "publicComment",
			component: () => import("@/components/public/PublicComment"),
			linkActiveClass: "active",
			meta: {
				title: "评论列表"
			}
		},
		{
			path: "/coupon_list",
			name: "couponList",
			component: () => import("@/components/coupon/CouponListNew"),
			linkActiveClass: "active",
			meta: {
				title: "我的卡券"
			}
		},
		{
			path: "/Coupon_information/:course_id?/:coupon_id?/:port_count?/:port_month?/:school_id?",
			name: "CouponInformation",
			component: () => import("@/components/coupon/CouponInformation"),
			linkActiveClass: "active",
			meta: {
				title: "确认兑换信息"
			}
		},
		{
			path: "/coupon_choice/:course_id?/:school_id?/:course_name?",
			name: "CouponChoice",
			component: () => import("@/components/coupon/CouponChoice"),
			linkActiveClass: "active",
			meta: {
				title: "选择兑换券"
			}
		},
		{
			path: "/coupon_detail/:coupon_id",
			name: "couponDetail",
			component: () => import("@/components/coupon/CouponDetail"),
			linkActiveClass: "active",
			meta: {
				title: "卡券详情"
			}
		},
		{
			path: "/card_bargaining/:coupon_id",
			name: "card_bargaining",
			component: () => import("@/components/coupon/CardBargaining"),
			linkActiveClass: "active",
			meta: {
				title: "砍价"
			}
		},
		{
			path: "/getsuccess",
			name: "getSuccess",
			component: () => import("@/components/coupon/GetSuccess"),
			linkActiveClass: "active",
			meta: {
				title: "领取话廊成功"
			}
		},
		{
			path: "/teacher_recommended",
			name: "teacherRecommended",
			component: () => import("@/components/teacher/TeacherRecommended"),
			linkActiveClass: "active",
			meta: {
				title: "每月推荐"
			}
		},

		// vip模块第二版 v2
		{
			path: "/vip_member_center_v2/:parent_id?",
			name: "vipmemberCenterV2",
			component: () => import("@/components/VIP_v2/VIPMemberCenter"),
			linkActiveClass: "active",
			meta: {
				title: "会员中心"
			}
		},
		{
			path: "/myschools",
			name: "MySchools",
			component: () => import("@/components/VIP_v2/MySchools"),
			linkActiveClass: "active",
			meta: {
				title: "我的机构"
			}
		},
		{
			path: "/mypromoteschools",
			name: "MyPromoteSchools",
			component: () => import("@/components/VIP_v2/MyPromoteSchools"),
			linkActiveClass: "active",
			meta: {
				title: "我的推广馆"
			}
		},

		//新版个人中心 -------- start
		{
			path: "/new_organization_center",
			name: "newOrganizationCenter",
			component: () =>
				import("@/components/new_profile/NewOrganizationCenter"),
			linkActiveClass: "active",
			meta: {
				title: "班级管理"
			}
		},
		{
			path: "/new_add_teacher",
			name: "newAddTeacher",
			component: () => import("@/components/new_profile/NewAddTeacher"),
			linkActiveClass: "active",
			meta: {
				title: "添加老师"
			}
		},
		{
			path: "/new_teacher_info/:teacher_id",
			name: "newTeacherInfo",
			component: () => import("@/components/new_profile/NewTeacherInfo"),
			linkActiveClass: "active",
			meta: {
				title: "老师详情"
			}
		},
		{
			path: "/new_class_info/:class_id",
			name: "record_attendanceDetail",
			component: () => import("@/components/new_profile/NewClassInfo"),
			linkActiveClass: "active",
			meta: {
				title: "班级详情"
			}
		},
		{
			path: "/new_add_class/:teacher_id",
			name: "newAddClass",
			component: () => import("@/components/new_profile/NewAddClass"),
			linkActiveClass: "active",
			meta: {
				title: "添加班级"
			}
		},
		{
			path: "/new_promotion_center/:parent_id?",
			name: "newPromotionCenter",
			component: () =>
				import("@/components/new_profile/NewPromotionCenter"),
			linkActiveClass: "active",
			meta: {
				title: "推广中心"
			}
		},
		{
			path: "/my_students_library",
			name: "mynewPromotionCenter",
			component: () =>
				import("@/components/new_profile/MyStudentsLibrary"),
			linkActiveClass: "active",
			meta: {
				title: "我的推广"
			}
		},
		{
			path: "/new_add_teacher_with_code/:school_id",
			name: "newAddTeacherWithCode",
			component: () =>
				import("@/components/new_profile/NewAddTeacherWithCode"),
			linkActiveClass: "active",
			meta: {
				title: "邀请老师 "
			}
		},
		{
			path: "/new_student_info/:class_id?/:student_id",
			name: "newStudentInfo",
			component: () => import("@/components/new_profile/NewStudentInfo"),
			linkActiveClass: "active",
			meta: {
				title: "学员详情 "
			}
		},
		{
			path: "/new_add_student/:class_id",
			name: "newAddStudent",
			component: () => import("@/components/new_profile/NewAddStudent"),
			linkActiveClass: "active",
			meta: {
				title: "添加单个学员 "
			}
		},
		{
			path: "/new_teacher_details/:teacher_id",
			name: "newTeacherDetails",
			component: () =>
				import("@/components/new_profile/NewTeacherDetails"),
			linkActiveClass: "active",
			meta: {
				title: "修改信息 "
			}
		},
		{
			path: "/new_update_class_info/:class_id",
			name: "newUpdateClassInfo",
			component: () =>
				import("@/components/new_profile/NewUpdateClassInfo"),
			linkActiveClass: "active",
			meta: {
				title: "修改班级信息"
			}
		},
		{
			path: "/new_input_mobile/:class_id",
			name: "newInputMobile",
			component: () => import("@/components/new_profile/NewInputMobile"),
			linkActiveClass: "active",
			meta: {
				title: "添加学员"
			}
		},
		{
			path: "/new_parent_child_list/:class_id/:mobile",
			name: "newParentChildList",
			component: () =>
				import("@/components/new_profile/NewParentChildList"),
			linkActiveClass: "active",
			meta: {
				title: "邀请加入班级"
			}
		},
		{
			path: "/new_batch_class/:class_id",
			name: "newBatchClass",
			component: () => import("@/components/new_profile/NewBatchClass"),
			linkActiveClass: "active",
			meta: {
				title: "批量转班"
			}
		},
		{
			path: "/new_batch_class_list",
			name: "newBatchClassList",
			component: () =>
				import("@/components/new_profile/NewBatchClassList"),
			linkActiveClass: "active",
			meta: {
				title: "批量转班"
			}
		},
		{
			path: "/new_transfer_class/:class_id?/:name?/:student_id",
			name: "newTransferClass",
			component: () =>
				import("@/components/new_profile/NewTransferClass"),
			linkActiveClass: "active",
			meta: {
				title: "学员转班"
			}
		},
		{
			path: "/new_add_single_student/:class_id?/:parent_id?",
			name: "newAddSingleStudent",
			component: () =>
				import("@/components/new_profile/NewAddSingleStudent"),
			linkActiveClass: "active",
			meta: {
				title: "添加学员"
			}
		},
		{
			path: "/new_parent_child_list/:class_id",
			name: "newCurrentChildList",
			component: () =>
				import("@/components/new_profile/NewCurrentChildList"),
			linkActiveClass: "active",
			meta: {
				title: "添加学员"
			}
		},
		{
			path: "/new_update_student/:student_id",
			name: "newUpdateStudent",
			component: () =>
				import("@/components/new_profile/NewUpdateStudent"),
			linkActiveClass: "active",
			meta: {
				title: "修改学员信息"
			}
		},
		{
			path: "/parent_update_student/:student_id",
			name: "parentUpdateStudent",
			component: () =>
				import("@/components/new_profile/parentUpdateStudent"),
			linkActiveClass: "active",
			meta: {
				title: "修改学员信息"
			}
		},

		{
			path: "/new_personal_homepage",
			name: "NewPersonalHomepage",
			component: () =>
				import("@/components/new_profile_v2/NewPersonalHomepage_v2"),
			linkActiveClass: "active",
			meta: {
				title: "个人中心"
			}
		},
		{
			path: "/new_light_management",
			name: "newLightManagement",
			component: () =>
				import("@/components/new_profile/NewLightManagement"),
			linkActiveClass: "active",
			meta: {
				title: "馆长轻管理"
			}
		},
		{
			path: "/new_old_student_management",
			name: "newOldStudentManagement",
			component: () =>
				import("@/components/new_profile/NewOldStudentManagement"),
			linkActiveClass: "active",
			meta: {
				title: "老生管理"
			}
		},
		{
			path: "/new_admissions_management",
			name: "newAdmissionsManagement",
			component: () =>
				import("@/components/new_profile/NewAdmissionsManagement"),
			linkActiveClass: "active",
			meta: {
				title: "招生助手"
			}
		},
		{
			path: "/new_statistical_management",
			name: "newStatisticalManagement",
			component: () =>
				import("@/components/new_profile/NewStatisticalManagement"),
			linkActiveClass: "active",
			meta: {
				title: "数据统计"
			}
		},
		{
			path: "/new_message_management",
			name: "newMessageManagement",
			component: () =>
				import("@/components/new_profile/NewMessageManagement"),
			linkActiveClass: "active",
			meta: {
				title: "消息管理"
			}
		},
		{
			path: "/new_message_teacher_management",
			name: "newMessageTeacherManagement",
			component: () =>
				import("@/components/new_profile/NewMessageTeacherManagement"),
			linkActiveClass: "active",
			meta: {
				title: "消息管理"
			}
		},
		{
			path: "/new_message_parent_management",
			name: "newMessageParentManagement",
			component: () =>
				import("@/components/new_profile/NewMessageParentManagement"),
			linkActiveClass: "active",
			meta: {
				title: "消息管理"
			}
		},
		{
			path: "/new_message_all_management",
			name: "newMessageAllManagement",
			component: () =>
				import("@/components/new_profile/NewMessageAllManagement"),
			linkActiveClass: "active",
			meta: {
				title: "家长钉"
			}
		},
		{
			path: "/new_imexperts",
			name: "newImExperts",
			component: () => import("@/components/new_profile/NewImExperts"),
			linkActiveClass: "active",
			meta: {
				title: "我是专家"
			}
		},
		{
			path: "/new_imteacher",
			name: "newImTeacher",
			component: () => import("@/components/new_profile/NewImTeacher"),
			linkActiveClass: "active",
			meta: {
				title: "我是老师"
			}
		},
		{
			path: "/new_imparent",
			name: "newImParent",
			component: () => import("@/components/new_profile/NewImParent"),
			linkActiveClass: "active",
			meta: {
				title: "我是家长"
			}
		},
		{
			path: "/new_support_management",
			name: "newSupportManagement",
			component: () =>
				import("@/components/new_profile/NewSupportManagement"),
			linkActiveClass: "active",
			meta: {
				title: "帮助中心"
			}
		},
		{
			path: "/new_add_single_student_with_parent/:class_id",
			name: "newAddSingleStudentWithParent",
			component: () =>
				import("@/components/new_profile/NewAddSingleStudentWithParent"),
			linkActiveClass: "active",
			meta: {
				title: "添加学员"
			}
		},
		{
			path: "/new_personal_homepage_v2",
			name: "NewPersonalHomepage_v2",
			component: () =>
				import("@/components/new_profile_v2/NewPersonalHomepage_v2"),
			linkActiveClass: "active",
			meta: {
				title: "个人中心"
			}
		},

		{
			path: "/school_management/:school_id?",
			name: "SchoolManagement",
			component: () =>
				import("@/components/new_profile_v2/SchoolManagement"),
			linkActiveClass: "active",
			meta: {
				title: "分馆管理"
			}
		},
		{
			path: "/teacher_management/:school_id?",
			name: "TeacherManagement",
			component: () =>
				import("@/components/new_profile_v2/TeacherManagement"),
			linkActiveClass: "active",
			meta: {
				title: "老师管理"
			}
		},
		{
			path: "/parent_management/:parent_id?",
			name: "ParentManagement",
			component: () =>
				import("@/components/new_profile_v2/ParentManagement"),
			linkActiveClass: "active",
			meta: {
				title: "话廊管理"
			}
		},
		{
			path: "/new_activity11/:parent_id?",
			name: "activity1111",
			component: () => import("@/components/coupon/Activity1111"),
			linkActiveClass: "active",
			meta: {
				title: "拼服务好续费"
			}
		},
		{
			path: "/I1680Info/:id1680",
			name: "I1680Info",
			component: () => import("@/components/coupon/I1680Info"),
			linkActiveClass: "active",
			meta: {
				title: "活动详情"
			}
		},
		{
			path: "/I1680InfoNoActive/:id1680",
			name: "I1680InfoNoActive",
			component: () => import("@/components/coupon/I1680InfoNoActive"),
			linkActiveClass: "active",
			meta: {
				title: "活动详情"
			}
		},
		{
			path: "/leave_students_base",
			name: "leavestudentsbase",
			component: () => import("@/components/student/LeaveStudentsBase"),
			linkActiveClass: "active",
			meta: {
				title: "离校生库"
			}
		},
		//游戏
		// {
		//     path: '/gonglue',
		//     name: 'GongLue',
		//     component: GongLue,
		//     linkActiveClass: 'active',
		//     meta: {
		//         title: '游戏攻略'
		//     }
		// },
		// {
		//     path: '/dig_ranking',
		//     name: 'DigRanking',
		//     component: DigRanking,
		//     linkActiveClass: 'active',
		//     meta: {
		//         title: '排行榜'
		//     }
		// },
		//圣诞帽
		// {
		//     path: '/hat',
		//     name: 'Hat',
		//     component: Hat,
		//     linkActiveClass: 'active',
		//     meta: {
		//         title: '圣诞帽'
		//     }
		// },
		// {
		//     path: '/new_avtar',
		//     name: 'NewAvtar',
		//     component: ()=>import('@/components/game/NewAvtar'),
		//     linkActiveClass: 'active',
		//     meta: {
		//         title: '领取专属头像'
		//     }
		// },
		//画报
		{
			path: "/canvas",
			name: "Canvas",
			component: () => import("@/components/test/Canvas"),
			linkActiveClass: "active",
			meta: {
				title: "画报"
			}
		},
		{
			path: "/work_comment_board",
			name: "Workcommentboard",
			component: () => import("@/components/public/WorkCommentBoard"),
			linkActiveClass: "active",
			meta: {
				title: "作品点评模板"
			}
		},
		{
			path: "/work_comment_add/:work_id/:comment_type/:student_id/:comment_id?",
			name: "workcommentadd",
			component: () => import("@/components/work/WorkCommentAdd"),
			linkActiveClass: "active",
			meta: {
				title: "作品点评",
				keepAlive: true
			}
		},
		{
			path: "/pay/course_detail_fund_:course_id",
			name: "courseDetailFund",
			component: () => import("@/components/course/CourseDetailsFund"),
			linkActiveClass: "active",
			meta: {
				title: "课程付款"
			}
		},
		{
			path: "/parent_course_list",
			name: "parentCourseList",
			component: () =>
				import("@/components/studentEnroll/ParentCourseList"),
			linkActiveClass: "active",
			meta: {
				title: "课程列表"
			}
		},
		{
			path: "/my_order_list/:tab_main?",
			name: "myOrderList",
			component: () => import("@/components/studentEnroll/MyOrderList"),
			linkActiveClass: "active",
			meta: {
				title: "我的订单"
			}
		},
		//赛事相关
		{
			path: "/match_promotion_code",
			name: "matchPromotionCode",
			component: () => import("@/components/match/matchPromotionCode"),
			linkActiveClass: "active",
			meta: {
				title: "赛事推广码"
			}
		},
		{
			path: "/match_promotion_search/:shool_id/:period_id",
			name: "matchPromotionSearch",
			component: () => import("@/components/match/matchPromotionSearch"),
			linkActiveClass: "active",
			meta: {
				title: "赛事推广查询"
			}
		},
		{
			path: "/match_promotion_search_list",
			name: "matchPromotionSearchList",
			component: () =>
				import("@/components/match/matchPromotionSearchList"),
			linkActiveClass: "active",
			meta: {
				title: "赛事推广查询"
			}
		},
		{
			path: "/match_student_search_list",
			name: "matchStudentSearchList",
			component: () =>
				import("@/components/match/matchStudentSearchList"),
			linkActiveClass: "active",
			meta: {
				title: "赛事推广查询"
			}
		},
		{
			path: "/match_list",
			name: "matchList",
			component: () => import("@/components/match/schoolMatchList"),
			linkActiveClass: "active",
			meta: {
				title: "赛事列表"
			}
		},
		{
			path: "/match_del/:match_id/:type?",
			name: "matchDel",
			component: () => import("@/components/match/matchDel"),
			linkActiveClass: "active",
			meta: {
				title: "赛事详情"
			}
		},
		{
			path: "/match_student_list",
			name: "matchStudentList",
			component: () => import("@/components/match/matchStudentList"),
			linkActiveClass: "active",
			meta: {
				title: "赛事列表"
			}
		},
		{
			path: "/pay/match_muti_school_pay_:school_ids?_:period_id?",
			name: "matchMutiPay",
			component: () => import("@/components/match/matchMutiPay"),
			linkActiveClass: "active",
			meta: {
				title: "赛事付款"
			}
		},
		{
			path: "/student_match_del/:match_id?/:student_id?/:work_id?/:school_id?",
			name: "studentMatchDel",
			component: () => import("@/components/match/studentMatchDel"),
			linkActiveClass: "active",
			meta: {
				title: "赛事详情"
			}
		},
		{
			path: "/pay/student_entry_information",
			name: "studentEntryInformation",
			component: () =>
				import("@/components/match/studentEntryInformation"),
			linkActiveClass: "active",
			meta: {
				title: "填写参赛信息"
			}
		},
		{
			path: "/match_success/:student_id?",
			name: "matchSuccess",
			component: () => import("@/components/match/matchSuccess"),
			linkActiveClass: "active",
			meta: {
				title: "报名成功"
			}
		},
		{
			path: "/match_work_list/:match_id?/:student_id?",
			name: "matchWorkList",
			component: () => import("@/components/match/matchWorkList"),
			linkActiveClass: "active",
			meta: {
				title: "选择作品"
			}
		},
		{
			path: "/match_school_order",
			name: "matchSchoolOrder",
			component: () => import("@/components/match/matchSchoolOrder"),
			linkActiveClass: "active",
			meta: {
				title: "查看订单"
			}
		},
		{
			path: "/match_poster",
			name: "matchPoster",
			component: () => import("@/components/match/matchPoster"),
			linkActiveClass: "active",
			meta: {
				title: "喜报"
			}
		},
		{
			path: "/match_school_achievement/:match_id?",
			name: "schoolMacthAchievement",
			component: () =>
				import("@/components/match/schoolMacthAchievement"),
			linkActiveClass: "active",
			meta: {
				title: "查看成绩"
			}
		},
		{
			path: "/student_match_result/:match_id?/:student_id?/:work_id?",
			name: "studentMacthResult",
			component: () => import("@/components/match/studentMacthResult"),
			linkActiveClass: "active",
			meta: {
				title: "查看成绩"
			}
		},
		{
			path: "/match_evaluated/:match_id?/:student_id?/:work_id?",
			name: "MacthEvaluated",
			component: () => import("@/components/match/MacthEvaluated"),
			linkActiveClass: "active",
			meta: {
				title: "待评作品"
			}
		},
		{
			path: "/teacher_match_list",
			name: "teacherMatchList",
			component: () => import("@/components/match/teacherMatchList"),
			linkActiveClass: "active",
			meta: {
				title: "赛事"
			}
		},
		{
			path: "/teacher_match_det/:match_id?/:work_id?",
			name: "teacherMatchDet",
			component: () => import("@/components/match/teacherMatchDet"),
			linkActiveClass: "active",
			meta: {
				title: "作品评奖详情"
			}
		},
		/** ***************************  **/
		{
			path: "/course_pay_list/:course_id?",
			name: "CoursePayList",
			component: () => import("@/components/course/CoursePayList"),
			linkActiveClass: "active",
			meta: {
				title: "课程付费列表"
			}
		},
		{
			path: "/course_bm_success/:order_id?",
			name: "CourseBmSuccess",
			component: () => import("@/components/course/CourseBmSuccess"),
			linkActiveClass: "active",
			meta: {
				title: "课程报名成功"
			}
		},
		{
			path: "/course_hx/:order_id?",
			name: "CourseHx",
			component: () => import("@/components/course/CourseHx"),
			linkActiveClass: "active",
			meta: {
				title: "课程核销"
			}
		},
		{
			path: "/course_hx_del/:order_id?",
			name: "CourseHxDel",
			component: () => import("@/components/course/CourseHxDel"),
			linkActiveClass: "active",
			meta: {
				title: "课程核销详情"
			}
		},
		{
			path: "/gallery_search/:selkey?",
			name: "GallerySearch",
			component: () => import("@/components/gallery/GallerySearch"),
			linkActiveClass: "active",
			meta: {
				title: "话廊搜索"
			}
		},

		{
			path: "/blog_details/:id",
			name: "blogDetails",
			component: () => import("@/components/home/TopLineDetails"),
			linkActiveClass: "active",
			meta: {
				title: "详情"
			}
		},
		{
			path: "/exclusive/:student_id",
			name: "Exclusive",
			component: () => import("@/components/gallery/Exclusive"),
			linkActiveClass: "active",
			meta: {
				title: "专属码"
			}
		},
		{
			path: "/PaintingFriendList/:student_id",
			name: "PaintingFriendList",
			component: () => import("@/components/gallery/PaintingFriendList"),
			linkActiveClass: "active",
			meta: {
				title: "我的话友"
			}
		},
		{
			path: "/search_painting/:student_id",
			name: "SearchPainting",
			component: () => import("@/components/gallery/SearchPainting"),
			linkActiveClass: "active",
			meta: {
				title: "搜索话友"
			}
		},
		{
			path: "/gallery_parent_work/:student_id?/:type?/:student_name?",
			name: "GalleryParentWork",
			component: () => import("@/components/gallery/GalleryParentWork"),
			linkActiveClass: "active",
			meta: {
				title: "课后作业"
			}
		},
		{
			path: "/parent_work_add/:student_id?",
			name: "WorkParentWorkAdd",
			component: () => import("@/components/work/WorkParentWorkAdd"),
			linkActiveClass: "active",
			meta: {
				title: "家长上传作品"
			}
		},
		{
			path: "/parent_work_del/:work_id?/:student_id?",
			name: "WorkParentWorkDel",
			component: () => import("@/components/work/WorkParentWorkDel"),
			linkActiveClass: "active",
			meta: {
				title: "课后作业"
			}
		},
		{
			path: "/parent_work_edit/:work_id?/:student_id?",
			name: "WorkParentWorkEdit",
			component: () => import("@/components/work/WorkParentWorkEdit"),
			linkActiveClass: "active",
			meta: {
				title: "作品修改"
			}
		},

		{
			path: "/maincloudcourse/:parent_id?",
			name: "mainCloudCourse",
			component: () => import("@/components/cloudCourse/MainPage"),
			linkActiveClass: "active",
			meta: {
				title: "云课程推荐"
			}
		},
		{
			path: "/selectppt/:parent_id?",
			name: "selectppt",
			component: () => import("@/components/cloudCourse/selectppt"),
			linkActiveClass: "active",
			meta: {
				title: "PPT推荐"
			}
		},
		{
			path: "/selectvideo/:parent_id?",
			name: "selectvideo",
			component: () => import("@/components/cloudCourse/selectvideo"),
			linkActiveClass: "active",
			meta: {
				title: "视频推荐"
			}
		},

		{
			path: "/cloudcourse/:taball_id?/:school_id?/:schoolName?",
			name: "cloudCourse",
			component: () => import("@/components/cloudCourse/courseMainPage"),
			linkActiveClass: "active",
			meta: {
				title: "云课程"
			}
		},
		{
			path: "/pay/pptcoursedetail_:course_id?",
			name: "pptCourseDetail",
			component: () => import("@/components/cloudCourse/pptCourseDetail"),
			linkActiveClass: "active",
			meta: {
				title: "PPT课件详情"
			}
		},
		{
			path: "/pay/pptcoursedetailbao_:course_id?",
			name: "pptCourseDetailBao",
			component: () =>
				import("@/components/cloudCourse/pptCourseDetailBao"),
			linkActiveClass: "active",
			meta: {
				title: "PPT课件详情"
			}
		},
		{
			path: "/pay/videocoursedetail_:course_id?",
			name: "videoCourseDetail",
			component: () =>
				import("@/components/cloudCourse/videoCourseDetail"),
			linkActiveClass: "active",
			meta: {
				title: "视频课件详情"
			}
		},
		{
			path: "/pay/videocoursedetailbao_:course_id?",
			name: "videoCourseDetaiBao",
			component: () =>
				import("@/components/cloudCourse/videoCourseDetaiBao"),
			linkActiveClass: "active",
			meta: {
				title: "视频课件详情"
			}
		},
		{
			path: "/platformcourse_:course_id?/:student_id?/:parent_id?",
			name: "platformCourse",
			component: () => import("@/components/cloudCourse/platformCourse"),
			linkActiveClass: "active",
			meta: {
				title: "平台课程详情"
			}
		},
		{
			path: "/guize/:course_id?/:parent_id?/:buy_school_id?/:order_typ?",
			name: "platforGuize",
			component: () => import("@/components/cloudCourse/platforGuize"),
			linkActiveClass: "active",
			meta: {
				title: "平台课程引导"
			}
		},
		{
			path: "/pay/doublecoursedetail_:course_id?",
			name: "doubleCourseDetail",
			component: () =>
				import("@/components/cloudCourse/doubleCourseDetail"),
			linkActiveClass: "active",
			meta: {
				title: "双师课程详情"
			}
		},
		{
			path: "/pay/buydoublecourse_:course_id?",
			name: "buyDoubleCourse",
			component: () => import("@/components/cloudCourse/buyDoubleCourse"),
			linkActiveClass: "active",
			meta: {
				title: "填写订单信息"
			}
		},
		{
			path: "/pay/buydoublecourseconfirm",
			name: "buyDoubleCourseConfirm",
			component: () =>
				import("@/components/cloudCourse/buyDoubleCourseConfirm"),
			linkActiveClass: "active",
			meta: {
				title: "确认订单信息"
			}
		},
		{
			path: "/pay/renewaldoublecourse_:course_id?",
			name: "renewalDoubleCourse",
			component: () =>
				import("@/components/cloudCourse/renewalDoubleCourse"),
			linkActiveClass: "active",
			meta: {
				title: "立即续费"
			}
		},
		{
			path: "/pay/renewaldoublecourseconfirm",
			name: "renewalDoubleCourseConfirm",
			component: () =>
				import("@/components/cloudCourse/renewalDoubleCourseConfirm"),
			linkActiveClass: "active",
			meta: {
				title: "确认订单信息"
			}
		},
		{
			path: "/pptbuysucess/:course_title?/:fee?",
			name: "pptBuySucess",
			component: () => import("@/components/cloudCourse/pptBuySucess"),
			linkActiveClass: "active",
			meta: {
				title: "购买成功"
			}
		},
		{
			path: "/doublecoursebuysucess/:fee?/:start_time?/:end_time?",
			name: "doubleCourseBuySucess",
			component: () =>
				import("@/components/cloudCourse/doubleCourseBuySucess"),
			linkActiveClass: "active",
			meta: {
				title: "购买成功"
			}
		},
		{
			path: "/exchangesucess/:course_id?",
			name: "ExchangeSucess",
			component: () => import("@/components/cloudCourse/ExchangeSucess"),
			linkActiveClass: "active",
			meta: {
				title: "兑换成功"
			}
		},
		{
			path: "/doublecourserenewalbuysucess/:buy_time?/:port_count?",
			name: "doubleCourseRenewalBuySucess",
			component: () =>
				import("@/components/cloudCourse/doubleCourseRenewalBuySucess"),
			linkActiveClass: "active",
			meta: {
				title: "续费成功"
			}
		},
		{
			path: "/doublecoursedetailtwo/:detail_id?",
			name: "doubleCourseDetailTwo",
			component: () =>
				import("@/components/cloudCourse/doubleCourseDetailTwo"),
			linkActiveClass: "active",
			meta: {
				title: "双师课程详情"
			}
		},

		{
			path: "/doublecoursedetailsucai/:detail_id?",
			name: "doubleCourseDetailSucai",
			component: () =>
				import("@/components/cloudCourse/doubleCourseDetailSucai"),
			linkActiveClass: "active",
			meta: {
				title: "课程素材包"
			}
		},
		{
			path: "/alreadyboughtcourse",
			name: "alreadyBoughtCourse",
			component: () =>
				import("@/components/cloudCourse/alreadyBoughtCourse"),
			linkActiveClass: "active",
			meta: {
				title: "已购课程"
			}
		},
		{
			path: "/alreadyboughtcourseGZLS",
			name: "alreadyBoughtCourseGZLS",
			component: () =>
				import("@/components/cloudCourse/alreadyBoughtCourseGZLS"),
			linkActiveClass: "active",
			meta: {
				title: "已购课程"
			}
		},
		{
			path: "/courseinformation/:course_id?",
			name: "courseInformation",
			component: () =>
				import("@/components/cloudCourse/courseInformation"),
			linkActiveClass: "active",
			meta: {
				title: "课程信息"
			}
		},

		{
			path: "/create_succee_page/:id?/:type?/:courseType?/:fee_type?", //id: 活动或者课程的id  //type : type：1课程 2 活动 courseType 课程的一份分类 ：普通课程 还是活动课程  课程类型
			name: "createSucceePage",
			component: () => import("@/components/course/CreateSucceePage"),
			linkActiveClass: "active",
			meta: {
				title: "发布成功"
			}
		},

		/*
		    所有公益活动路由按照分类，放在公益活动系列
		    每个活动开始路由跟结束路由，做好注释分割
		*/

		/* ---------------------------公益活动系列----------------------------------------- */

		/********************** 抢学费活动开始 **********************************/
		{
			path: "/public_welfare_home3/:parent_id?",
			name: "PublicWlfareHome3",
			component: () =>
				import("@/components/activityPublicWelfare/PublicWlfareHome"),
			linkActiveClass: "active",
			meta: {
				title: "抢学费"
			}
		},
		{
			path: "/student_apply3/:parent_id?",
			name: "StudentApply3",
			component: () =>
				import("@/components/activityPublicWelfare/StudentApply"),
			linkActiveClass: "active",
			meta: {
				title: "立即申请"
			}
		},
		{
			path: "/student_apply_yes3",
			name: "StudentApplyYes3",
			component: () =>
				import("@/components/activityPublicWelfare/StudentApplyYes"),
			linkActiveClass: "active",
			meta: {
				title: "报名成功"
			}
		},
		{
			path: "/my_commonweal3",
			name: "MyCommonweal3",
			component: () =>
				import("@/components/activityPublicWelfare/MyCommonweal"),
			linkActiveClass: "active",
			meta: {
				title: "我的公益"
			}
		},
		{
			path: "/public_welfare_school_sign3",
			name: "schoolSign3",
			component: () =>
				import("@/components/activityPublicWelfare/SchoolSign"),
			linkActiveClass: "active",
			meta: {
				title: "机构报名"
			}
		},
		{
			path: "/school_pwinfo3",
			name: "schoolPWInfo3",
			component: () =>
				import("@/components/activityPublicWelfare/SchoolPWInfo"),
			linkActiveClass: "active",
			meta: {
				title: "机构活动详情"
			}
		},
		{
			path: "/school_info_update3/:school_id?",
			name: "schoolInfoUpdate3",
			component: () =>
				import("@/components/activityPublicWelfare/SchoolInfoUpdate"),
			linkActiveClass: "active",
			meta: {
				title: "修改联系人"
			}
		},
		{
			path: "/my_recommendation3",
			name: "MyRecommendation3",
			component: () =>
				import("@/components/activityPublicWelfare/MyRecommendation"),
			linkActiveClass: "active",
			meta: {
				title: "我的推荐"
			}
		},
		{
			path: "/apply_introducer3",
			name: "ApplyIntroducer3",
			component: () =>
				import("@/components/activityPublicWelfare/ApplyIntroducer"),
			linkActiveClass: "active",
			meta: {
				title: "公益分享"
			}
		},
		{
			path: "/apply_introducer_yes3/:name?",
			name: "ApplyIntroducerYes3",
			component: () =>
				import("@/components/activityPublicWelfare/ApplyIntroducerYes"),
			linkActiveClass: "active",
			meta: {
				title: "公益分享"
			}
		},
		{
			path: "/gy_rules3",
			name: "GyRules3",
			component: () =>
				import("@/components/activityPublicWelfare/GyRules"),
			linkActiveClass: "active",
			meta: {
				title: "公益规则"
			}
		},
		/********************** 抢学费活动结束 **********************************/

		/********************** 致敬逆行者开始 **********************************/
		{
			path: "/public_welfare_home2/:parent_id?",
			name: "PublicWlfareHome2",
			component: () =>
				import("@/components/activityPublicWelfare2/PublicWlfareHome"),
			linkActiveClass: "active",
			meta: {
				title: "致敬逆行者"
			}
		},
		{
			path: "/student_apply2/:parent_id?",
			name: "StudentApply2",
			component: () =>
				import("@/components/activityPublicWelfare2/StudentApply"),
			linkActiveClass: "active",
			meta: {
				title: "立即申请"
			}
		},
		{
			path: "/student_apply_yes2",
			name: "StudentApplyYes2",
			component: () =>
				import("@/components/activityPublicWelfare2/StudentApplyYes"),
			linkActiveClass: "active",
			meta: {
				title: "报名成功"
			}
		},
		{
			path: "/my_commonweal2",
			name: "MyCommonweal2",
			component: () =>
				import("@/components/activityPublicWelfare2/MyCommonweal"),
			linkActiveClass: "active",
			meta: {
				title: "我的公益"
			}
		},
		{
			path: "/public_welfare_school_sign2",
			name: "schoolSign2",
			component: () =>
				import("@/components/activityPublicWelfare2/SchoolSign"),
			linkActiveClass: "active",
			meta: {
				title: "机构报名"
			}
		},
		{
			path: "/school_pwinfo2",
			name: "schoolPWInfo2",
			component: () =>
				import("@/components/activityPublicWelfare2/SchoolPWInfo"),
			linkActiveClass: "active",
			meta: {
				title: "机构活动详情"
			}
		},
		{
			path: "/school_info_update2/:school_id?",
			name: "schoolInfoUpdate2",
			component: () =>
				import("@/components/activityPublicWelfare2/SchoolInfoUpdate"),
			linkActiveClass: "active",
			meta: {
				title: "修改联系人"
			}
		},
		{
			path: "/my_recommendation2",
			name: "MyRecommendation2",
			component: () =>
				import("@/components/activityPublicWelfare2/MyRecommendation"),
			linkActiveClass: "active",
			meta: {
				title: "我的推荐"
			}
		},
		{
			path: "/apply_introducer2",
			name: "ApplyIntroducer2",
			component: () =>
				import("@/components/activityPublicWelfare2/ApplyIntroducer"),
			linkActiveClass: "active",
			meta: {
				title: "公益分享"
			}
		},
		{
			path: "/gy_rules2",
			name: "GyRules2",
			component: () =>
				import("@/components/activityPublicWelfare2/GyRules"),
			linkActiveClass: "active",
			meta: {
				title: "公益规则"
			}
		},
		/********************** 致敬逆行者结束 **********************************/

		/********************** 暑假班活动开始   ***********************************/
		{
			path: "/public_welfare_home4/:parent_id?",
			name: "PublicWlfareHome4",
			component: () =>
				import("@/components/activityPublicWelfare3/PublicWlfareHome"),
			linkActiveClass: "active",
			meta: {
				title: "暑假班"
			}
		},
		{
			path: "/student_apply4/:parent_id?",
			name: "StudentApply4",
			component: () =>
				import("@/components/activityPublicWelfare3/StudentApply"),
			linkActiveClass: "active",
			meta: {
				title: "立即申请"
			}
		},
		{
			path: "/student_apply_yes4",
			name: "StudentApplyYes4",
			component: () =>
				import("@/components/activityPublicWelfare3/StudentApplyYes"),
			linkActiveClass: "active",
			meta: {
				title: "报名成功"
			}
		},
		{
			path: "/my_commonweal4",
			name: "MyCommonweal4",
			component: () =>
				import("@/components/activityPublicWelfare3/MyCommonweal"),
			linkActiveClass: "active",
			meta: {
				title: "我的公益"
			}
		},
		{
			path: "/public_welfare_school_sign4",
			name: "schoolSign4",
			component: () =>
				import("@/components/activityPublicWelfare3/SchoolSign"),
			linkActiveClass: "active",
			meta: {
				title: "机构报名"
			}
		},
		{
			path: "/school_pwinfo4",
			name: "schoolPWInfo4",
			component: () =>
				import("@/components/activityPublicWelfare3/SchoolPWInfo"),
			linkActiveClass: "active",
			meta: {
				title: "机构活动详情"
			}
		},
		{
			path: "/school_info_update4/:school_id?",
			name: "schoolInfoUpdate4",
			component: () =>
				import("@/components/activityPublicWelfare3/SchoolInfoUpdate"),
			linkActiveClass: "active",
			meta: {
				title: "修改联系人"
			}
		},
		{
			path: "/my_recommendation4",
			name: "MyRecommendation4",
			component: () =>
				import("@/components/activityPublicWelfare3/MyRecommendation"),
			linkActiveClass: "active",
			meta: {
				title: "我的推荐"
			}
		},
		{
			path: "/apply_introducer4",
			name: "ApplyIntroducer4",
			component: () =>
				import("@/components/activityPublicWelfare3/ApplyIntroducer"),
			linkActiveClass: "active",
			meta: {
				title: "公益分享"
			}
		},
		{
			path: "/apply_introducer_yes4/:name?",
			name: "ApplyIntroducerYes4",
			component: () =>
				import("@/components/activityPublicWelfare3/ApplyIntroducerYes"),
			linkActiveClass: "active",
			meta: {
				title: "公益分享"
			}
		},
		{
			path: "/gy_rules4",
			name: "GyRules4",
			component: () =>
				import("@/components/activityPublicWelfare3/GyRules"),
			linkActiveClass: "active",
			meta: {
				title: "公益规则"
			}
		},
		/********************** 暑假班活动结束  ***********************************/

		/********************** 抢名额活动开始   ***********************************/
		{
			path: "/public_welfare_home/:parent_id?",
			name: "PublicWlfareHome",
			component: () =>
				import("@/components/activityPublicWelfare4/PublicWlfareHome"),
			linkActiveClass: "active",
			meta: {
				title: "抢名额"
			}
		},
		{
			path: "/student_apply/:parent_id?",
			name: "StudentApply",
			component: () =>
				import("@/components/activityPublicWelfare4/StudentApply"),
			linkActiveClass: "active",
			meta: {
				title: "立即申请"
			}
		},
		{
			path: "/student_apply_yes",
			name: "StudentApplyYes",
			component: () =>
				import("@/components/activityPublicWelfare4/StudentApplyYes"),
			linkActiveClass: "active",
			meta: {
				title: "报名成功"
			}
		},
		{
			path: "/my_commonweal",
			name: "MyCommonweal",
			component: () =>
				import("@/components/activityPublicWelfare4/MyCommonweal"),
			linkActiveClass: "active",
			meta: {
				title: "我的公益"
			}
		},
		{
			path: "/public_welfare_school_sign",
			name: "schoolSign",
			component: () =>
				import("@/components/activityPublicWelfare4/SchoolSign"),
			linkActiveClass: "active",
			meta: {
				title: "机构报名"
			}
		},
		{
			path: "/school_pwinfo",
			name: "schoolPWInfo",
			component: () =>
				import("@/components/activityPublicWelfare4/SchoolPWInfo"),
			linkActiveClass: "active",
			meta: {
				title: "机构活动详情"
			}
		},
		{
			path: "/school_info_update/:school_id?",
			name: "schoolInfoUpdate",
			component: () =>
				import("@/components/activityPublicWelfare4/SchoolInfoUpdate"),
			linkActiveClass: "active",
			meta: {
				title: "修改联系人"
			}
		},
		{
			path: "/my_recommendation",
			name: "MyRecommendation",
			component: () =>
				import("@/components/activityPublicWelfare4/MyRecommendation"),
			linkActiveClass: "active",
			meta: {
				title: "我的推荐"
			}
		},
		{
			path: "/apply_introducer",
			name: "ApplyIntroducer",
			component: () =>
				import("@/components/activityPublicWelfare4/ApplyIntroducer"),
			linkActiveClass: "active",
			meta: {
				title: "公益分享"
			}
		},
		{
			path: "/apply_introducer_yes/:name?",
			name: "ApplyIntroducerYes",
			component: () =>
				import("@/components/activityPublicWelfare4/ApplyIntroducerYes"),
			linkActiveClass: "active",
			meta: {
				title: "公益分享"
			}
		},
		{
			path: "/gy_rules",
			name: "GyRules",
			component: () =>
				import("@/components/activityPublicWelfare4/GyRules"),
			linkActiveClass: "active",
			meta: {
				title: "公益规则"
			}
		},
		{
			path: "/page_02/:parentId?",
			name: "page_02",
			component: () => import("@/components/new_profile/page_02"),
			linkActiveClass: "active",
			meta: {
				title: "合伙人招募"
			}
		},
		{
			path: "/page_03/:parentId?",
			name: "page_03",
			component: () => import("@/components/new_profile/page_03"),
			linkActiveClass: "active",
			meta: {
				title: "联系我们"
			}
		},
		{
			path: "/page_06/:parentId?",
			name: "page_06",
			component: () => import("@/components/new_profile/page_06"),
			linkActiveClass: "active",
			meta: {
				title: "家长话廊"
			}
		},
		{
			path: "/page_07/:parentId?",
			name: "page_07",
			component: () => import("@/components/new_profile/page_07"),
			linkActiveClass: "active",
			meta: {
				title: "共享计划"
			}
		},
		{
			path: "/page_01/:parentId?",
			name: "page01",
			component: () =>
				import("@/components/new_profile/Page01"),
			linkActiveClass: "active",
			meta: {
				title: "机构入驻"
			}
		},
		{
			path: "/page_04/:parentId?",
			name: "page04",
			component: () => import("@/components/new_profile/Page04"),
			linkActiveClass: "active",
			meta: {
				title: "机构云课程"
			}
		},
		{
			path: "/page_05/:parentId?",
			name: "page05",
			component: () => import("@/components/new_profile/page05"),
			linkActiveClass: "active",
			meta: {
				title: "机构详情"
			}
		},
		//新版创建话廊路由
		{
			path: "/gallery_create_new/:class_id?",
			name: "galleryCreateNew",
			component: () => import("@/components/gallery/galleryCreateNew"),
			linkActiveClass: "active",
			meta: {
				title: "创建话廊"
			}
		},
		{
			path: "/gallery_student_name_repeat/:name?/:studentId?/:classId?/:className?/:schoolName?/:schoolID?/:avatar?/:mobile?/:sex?/:birthday?/:guanxi?/:hualang?",
			name: "galleryStudentNameRepeat",
			component: () =>
				import("@/components/gallery/galleryStudentNameRepeatNew"),
			linkActiveClass: "active",
			meta: {
				title: "创建话廊"
			}
		},
		{
			path: "/gallery_create_success/:student_id",
			name: "galleryCreateSuccess",
			component: () =>
				import("@/components/gallery/galleryCreateSuccess"),
			linkActiveClass: "active",
			meta: {
				title: "创建话廊成功"
			}
		},
		{
			path: "/parent_see_gallery/:studentId?",
			name: "ParentSeeGallery",
			component: () => import("@/components/gallery/ParentSeeGallery"),
			linkActiveClass: "active",
			meta: {
				title: "查看话廊"
			}
		},
		{
			path: "/gallery_student_name_tourist/:studentName?/:avatar?/:parentMobile?/:sex?/:birthday?/:parentRelation?/:parentId?/:classId?/:UserId?/:course_id?/:old_fee?",
			name: "galleryStudentNameTourist",
			component: () =>
				import("@/components/gallery/galleryStudentNameTouristNew"),
			linkActiveClass: "active",
			meta: {
				title: "创建话廊"
			}
		},
		{
			path: "/galleryFriendsGroup/:studentId?",
			name: "galleryFriendsGroup",
			component: () => import("@/components/gallery/galleryFriendsGroup"),
			linkActiveClass: "active",
			meta: {
				title: "加入亲友团"
			}
		},
		{
			//    path: '/tourist_creation_success/:studentName?/:studentID?',
			path: "/tourist_creation_success/:studentID?/:old_fee?/:course_id?",
			name: "TouristCreationSuccess",
			component: () =>
				import("@/components/gallery/TouristCreationSuccess"),
			linkActiveClass: "active",
			meta: {
				title: "创建成功"
			}
		},
		{
			//家长分享的二维码，进入后的页面
			path: "/teacher_see_gallery/:studentID?/:parentId?/:type?/:course_id?/:old_fee?",
			name: "TeacherSeeGallery",
			component: () => import("@/components/gallery/TeacherSeeGallery"),
			linkActiveClass: "active",
			meta: {
				title: "话廊"
			}
		},
		{
			//游客创建话廊
			path: "/parent_create_gallery/:ClassID?/:parent_id?/:course_id?/:old_fee?",
			name: "ParentCreateGallery",
			component: () => import("@/components/gallery/ParentCreateGallery"),
			linkActiveClass: "active",
			meta: {
				title: "创建话廊"
			}
		},
		{
			//已上传作品列表页
			path: "/student_work_list/:studentName?/:studentId/:tid?/:cid?/:is?/:ETime?/:STime?/:sex/:headUrl?/:type",
			name: "StudentWorkList",
			component: () => import("@/components/work/StudentWorkList"),
			linkActiveClass: "active",
			meta: {
				title: "作品"
			}
		},
		{
			path: "/fg_school_teach/:FgSid?",
			name: "FgSchoolTeach",
			component: () => import("@/components/school/FgSchoolTeach"),
			linkActiveClass: "active",
			meta: {
				title: "授权"
			}
		},
		{
			//更换手机号  import AccountSetting from '@/components/profile/AccountSetting'
			path: "/profile_change_mobile",
			name: "ProfileChangeMobile",
			component: () => import("@/components/profile/ProfileChangeMobile"),
			linkActiveClass: "active",
			meta: {
				title: "更换手机号"
			}
		},
		//拼团相关路由
		{
			path: "/group_buying_rule",
			name: "groupBuyingRulea",
			component: () =>
				import("@/components/groupBuying/groupBuyingRulea"),
			linkActiveClass: "active",
			meta: {
				title: "拼团规则"
			}
		},
		{
			path: "/new_a",
			name: "NewA",
			component: () => import("@/components/new_profile_v2/NewA"),
			// component: NewPersonalHomepage,   3344
			linkActiveClass: "active",
			meta: {
				title: "dome"
			}
		},
		{
			path: "/xibaodemo",
			name: "xibaodemo",
			component: () => import("@/components/match/xibaodemo"),
			linkActiveClass: "active",
			meta: {
				title: "xibaodemo"
			}
		},

		//赛事
		{
			path: "/event_search/:student_id?",
			name: "EventSearch",
			component: () => import("@/components/event/EventSearch"),
			linkActiveClass: "active",
			meta: {
				title: "获奖查询"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/event_work_info/:work_id?",
			name: "EventWorkInfo",
			component: () => import("@/components/event/EventWorkInfo"),
			linkActiveClass: "active",
			meta: {
				title: "作品信息"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/pay/s_class_detial_:s_id?",
			name: "SClassDetial",
			component: () => import("@/components/home/SClassDetial"),
			linkActiveClass: "active",
			meta: {
				title: "购买直播课"
				//keepAlive: true //此组件不需要被缓存
			}
		},
		{
			path: "/signup_class/:s_id?",
			name: "SignUpClass",
			component: () => import("@/components/home/SignUpClass"),
			linkActiveClass: "active",
			meta: {
				title: "机构师训课"
			}
		},

		{
			path: "/workbench",
			name: "WorkBench",
			component: () => import("@/components/new_profile_v2/WorkBench"),
			linkActiveClass: "active",
			meta: {
				title: "工作台"
			}
		},

		{
			path: "/students_library",
			name: "studentsLibrary",
			component: () => import("@/components/new_profile/studentsLibrary"),
			linkActiveClass: "active",
			meta: {
				title: "生源酷"
			}
		},
		{
			path: "/set_teacherPromote",
			name: "setTeacherPromote",
			component: () =>
				import("@/components/new_profile/setTeacherPromote"),
			linkActiveClass: "active",
			meta: {
				title: "设置教师为推广大使"
			}
		},
		{
			path: "/set_userPromote",
			name: "setUserPromote",
			component: () => import("@/components/new_profile/setUserPromote"),
			linkActiveClass: "active",
			meta: {
				title: "设置家长为推广大使"
			}
		},
		{
			path: "/set_otherPromote",
			name: "setOtherPromote",
			component: () => import("@/components/new_profile/setOtherPromote"),
			linkActiveClass: "active",
			meta: {
				title: "设置推广大使"
			}
		},
		{
			path: "/set_rewardRules",
			name: "SetRewardRules",
			component: () => import("@/components/new_profile/SetRewardRules"),
			linkActiveClass: "active",
			meta: {
				title: "设置奖励规则"
			}
		},
		{
			path: "/promotion_poster/:school_id?",
			name: "PromotionPoster",
			component: () => import("@/components/new_profile/PromotionPoster"),
			linkActiveClass: "active",
			meta: {
				title: "推广码"
			}
		},
		{
			path: "/promotion_rules",
			name: "PromotionRules",
			component: () => import("@/components/new_profile/PromotionRules"),
			linkActiveClass: "active",
			meta: {
				title: "推广规则及奖励"
			}
		},
		{
			path: "/student_invitation/:school_id?/:p_id?",
			name: "StudentInvitation",
			component: () =>
				import("@/components/new_profile/StudentInvitation"),
			linkActiveClass: "active",
			meta: {
				title: "领取"
			}
		},
		{
			path: "/mylivelesson",
			name: "MyLiveLesson",
			component: () => import("@/components/home/MyLiveLesson"),
			linkActiveClass: "active",
			meta: {
				title: "我的直播课"
			}
		},
		{
			path: "/buyedclassdetial/:s_id?",
			name: "buyedClassDetial",
			component: () => import("@/components/home/buyedClassDetial"),
			linkActiveClass: "active",
			meta: {
				title: "已购直播课"
			}
		},

		// 考勤缴费管理
		// =============start================

		// 课程维护 ------start
		{
			path: "/course_lottery_draw",
			name: "courseLotteryDraw",
			component: () =>
				import("@/components/attendance/courseLotteryDraw"),
			linkActiveClass: "active",
			meta: {
				title: "系统课抽奖"
			}
		},
		{
			path: "/add_preferentialCourse",
			name: "addPreferentialCourse",
			component: () =>
				import("@/components/attendance/addPreferentialCourse"),
			linkActiveClass: "active",
			meta: {
				title: "新增课程"
			}
		},
		{
			path: "/course_management",
			name: "CourseManagement",
			component: () => import("@/components/attendance/CourseManagement"),
			linkActiveClass: "active",
			meta: {
				title: "课程管理"
			}
		},
		{
			// path: "/course_manage_detail",
			path: "/course_manage_detail/:id",
			name: "CourseManageDetail",
			component: () => import("@/components/attendance/CourseManageDetail"),
			linkActiveClass: "active",
			meta: {
				title: "课程详情"
			}
		},
		{
			// path: "/edit_preferentialCourse/:course_id?",
			path: "/edit_preferentialCourse/:id",
			name: "editPreferentialCourse",
			// component: () => import("@/components/attendance/editPreferentialCourse"),
			component: () => import("@/components/attendance/addPreferentialCourse"),
			linkActiveClass: "active",
			meta: {
				title: "修改课程"
			}
		},
		//线上系统课详情
		{
			path: "/online_course_detail/:service_id",
			name: "OnlineCourseDetail",
			component: () => import("@/pages/onlineCourse/courseDetail"),
			linkActiveClass: "active",
			meta: {
				title: "系统课"
			}
		},
		{
			path: "/coursePreferential/:id",
			name: "coursePreferential",
			component: () => import("@/pages/feeManagement/coursePreferential"),
			linkActiveClass: "active",
			meta: {
				title: "课程优惠"
			}

		},
		{
			path: "/buyCourse/:id",
			name: "buyCourse",
			component: () => import("@/pages/onlineCourse/buyCourse"),
			linkActiveClass: "active",
			meta: {
				title: "购买系统课"
			}
		},

		{
			path: "/online_course_down",
			name: "CourseDown",
			component: () => import("@/pages/onlineCourse/onlineDown"),
			linkActiveClass: "active",
			meta: {
				title: "系统课详情-已下架"
			}
		},
		{
			path: "/online_signup_ok",
			name: "OnlineSignupOk",
			component: () => import("@/pages/onlineCourse/signupOk"),
			linkActiveClass: "active",
			meta: {
				title: "系统课详情-报名成功"
			}
		},
		{
			path: "/online_signup_infos",
			name: "OnlineSignupInfo",
			component: () => import("@/pages/feeManagement/onlineSignInfos"),
			linkActiveClass: "active",
			meta: {
				title: "线上报名信息"
			}
		},
		{
			path: "/giveCourse/:id",
			name: "giveCourse",
			component: () => import("@/pages/feeManagement/giveCourse"),
			linkActiveClass: "active",
			meta: {
				title: "推荐赠课"
			}
		},
		{
			path: "/myCourse",
			name: "myCourse",
			component: () =>
				import("@/components/spellGroup/myCourse.vue"),
			linkActiveClass: "active",
			meta: {
				title: "报学课程-合并"
			}
		},
		{
			path: "/mycourse_statement",
			name: "MyCourseStatement",
			component: () => import("@/pages/onlineCourse/mycourseStatement"),
			linkActiveClass: "active",
			meta: {
				title: "报学课程-查看明细"
			}
		},
		{
			path: "/fee_manage",
			name: "Feemanage",
			component: () => import("@/pages/feeManagement/feeManage"),
			linkActiveClass: "active",
			meta: {
				title: "缴费管理"
			}
		},
		{
			path: "/fee_manage_refund",
			name: "FeemanageRefund",
			component: () => import("@/pages/feeManagement/refund"),
			linkActiveClass: "active",
			meta: {
				title: "缴费管理-查看退费"
			}
		},
		{
			path: "/fee_manage_transcourse",
			name: "FeemanageTrans",
			component: () => import("@/pages/feeManagement/transCourse"),
			linkActiveClass: "active",
			meta: {
				title: "缴费管理-办理转课"
			}
		},
		{
			path: "/fee_manage_cash",
			name: "FeemanageCash",
			component: () => import("@/pages/feeManagement/cash"),
			linkActiveClass: "active",
			meta: {
				title: "缴费管理-线上缴费结算"
			}
		},
		{
			path: "/fee_manage_cashform",
			name: "FeemanageCashform",
			component: () => import("@/pages/feeManagement/cashform"),
			linkActiveClass: "active",
			meta: {
				title: "缴费管理-申请结算"
			}
		},
		{
			path: "/fee_manage_cashing_detail",
			name: "FeemanageCashingDetail",
			component: () => import("@/pages/feeManagement/cashingDetail"),
			linkActiveClass: "active",
			meta: {
				title: "缴费管理-结算中详情"
			}
		},
		{
			path: "/fee_manage_cashed_detail",
			name: "FeemanageCashedDetail",
			component: () => import("@/pages/feeManagement/finishcashDetail"),
			linkActiveClass: "active",
			meta: {
				title: "缴费管理-订单结算"
			}
		},

		{
			path: "/add_fullFold/:type?",
			name: "AddFullFold",
			// component: () => import("@/components/attendance/AddFullFold"),
			component: () => import("@/components/attendance/AddPreferential"),
			linkActiveClass: "active",
			meta: {
				title: "新建满折"
			}
		},
		{
			path: "/add_fullReduction/:type?",
			name: "AddFullReduction",
			// component: () => import("@/components/attendance/AddFullReduction"),
			component: () => import("@/components/attendance/AddPreferential"),
			linkActiveClass: "active",
			meta: {
				title: "新建满减"
			}
		},
		{
			path: "/add_giveClass/:type?",
			name: "AddGiveClass",
			// component: () => import("@/components/attendance/AddGiveClass"),
			component: () => import("@/components/attendance/AddPreferential"),
			linkActiveClass: "active",
			meta: {
				title: "新建赠送课时"
			}
		},
		{
			path: "/edit_fullFold/:discount_id?",
			name: "EditFullFold",
			component: () => import("@/components/attendance/EditFullFold"),
			linkActiveClass: "active",
			meta: {
				title: "编辑满折"
			}
		},
		{
			path: "/edit_fullReduction/:discount_id?",
			name: "EditFullReduction",
			component: () => import("@/components/attendance/EditFullReduction"),
			linkActiveClass: "active",
			meta: {
				title: "编辑满减"
			}
		},
		{
			path: "/Edit_giveClass/:discount_id?",
			name: "EditGiveClass",
			component: () => import("@/components/attendance/EditGiveClass"),
			linkActiveClass: "active",
			meta: {
				title: "编辑赠送课时"
			}
		},
		{
			path: "/fullFoldDetail/:id",
			// path: "/fullFoldDetail",
			name: "FullFoldDetail",
			// component: () => import("@/components/attendance/FullFoldDetail"),
			component: () => import("@/components/attendance/PreferentialDetail"),
			linkActiveClass: "active",
			meta: {
				title: "满折优惠"
			}
		},
		{
			path: "/fullReductionDetail/:id",
			// path: "/fullReductionDetail",
			name: "FullReductionDetail",
			component: () =>
				// import("@/components/attendance/FullReductionDetail"),
				import("@/components/attendance/PreferentialDetail"),
			linkActiveClass: "active",
			meta: {
				title: "满减优惠"
			}
		},
		{
			path: "/giveClassDetail/:id",
			// path: "/giveClassDetail",
			name: "GiveClassDetail",
			// component: () => import("@/components/attendance/GiveClassDetail"),
			component: () => import("@/components/attendance/PreferentialDetail"),
			linkActiveClass: "active",
			meta: {
				title: "赠送课时优惠"
			}
		},
		// 课程维护 ------end

		// 班级管理 ------start
		{
			path: "/new_organization_center_new/:isTeacher?",
			name: "newOrganizationCenter_new",
			component: () =>
				import("@/components/new_profile/NewOrganizationCenter_new"),
			linkActiveClass: "active",
			meta: {
				title: "班级管理"
			}
		},

		{
			path: "/allStudent",
			name: "allStudent",
			component: () =>
				import("@/components/new_profile/allStudent"),
			linkActiveClass: "active",
			meta: {
				title: "在读学员"
			}
		},
		{
			path: "/birthdayStudent/:isTeacher",
			name: "birthdayStudent",
			component: () =>
				import("@/components/new_profile/birthdayStudent"),
			linkActiveClass: "active",
			meta: {
				title: "生日学员"
			}
		},
		{
			path: "/unclaimedStudent/:isTeacher",
			name: "unclaimedStudent",
			component: () =>
				import("@/components/new_profile/unclaimedStudent"),
			linkActiveClass: "active",
			meta: {
				title: "未认领学员"
			}
		},
		{
			path: "/pendingStudent",
			name: "pendingStudent",
			component: () =>
				import("@/components/new_profile/pendingStudent"),
			linkActiveClass: "active",
			meta: {
				title: "待续费学员"
			}
		},

		{
			path: "/new_class_info_new/:class_id/:isTeacher?",
			name: "newClassInfo_new",
			component: () =>
				import("@/components/new_profile/NewClassInfo_new"),
			linkActiveClass: "active",
			meta: {
				title: "班级详情"
			}
		},
		// {
		//     path: "/new_class_editinfo_new/:class_id",
		//     name: "newEditClassInfo_new",
		//     component: () =>
		//         import("@/components/new_profile/NewEditClassInfo_new"),
		//     linkActiveClass: "active",
		//     meta: {
		//         title: "修改班级"
		//     }
		// },
		// {
		//     path: "/new_add_class_new/:teacher_id",
		//     name: "newAddClass_new",
		//     component: () => import("@/components/new_profile/NewAddClass_new"),
		//     linkActiveClass: "active",
		//     meta: {
		//         title: "添加班级"
		//     }
		// },
		{
			path: "/new_class_editinfo_new/:class_id",
			name: "newEditClassInfo_new",
			component: () =>
				import("@/components/new_profile/NewAddClass_new"),
			linkActiveClass: "active",
			meta: {
				title: "修改班级"
			}
		},
		{
			path: "/new_add_class_new/:teacher_id",
			name: "newAddClass_new",
			component: () => import("@/components/new_profile/NewAddClass_new"),
			linkActiveClass: "active",
			meta: {
				title: "添加班级"
			}
		},
		{
			path: "/student_detail02/:student_id/:isTeacher",
			name: "StudentDetail02",
			component: () => import("@/components/attendance/StudentDetail"),
			linkActiveClass: "active",
			meta: {
				title: "学员详情"
			}
		},
		{
			path: "/leavingClass/:student_id/:class_id?",
			name: "leavingClass",
			component: () => import("@/components/attendance/leavingClass.vue"),
			linkActiveClass: "active",
			meta: {
				title: "办理离班"
			}
		},
		// 班级管理 ------end
		// 报学课程 ------start
		{
			path: "/school_authorization",
			name: "SchoolAuthorization",
			component: () =>
				import("@/components/attendance/SchoolAuthorization"),
			linkActiveClass: "active",
			meta: {
				title: "校管授权"
			}
		},
		{
			path: "/configurePermissions",
			name: "ConfigurePermissions",
			component: () =>
				import("@/components/attendance/configurePermissions"),
			linkActiveClass: "active",
			meta: {
				title: "配置权限"
			}
		},

		{
			path: "/enrollment_course/:student_id?",
			name: "EnrollmentCourse",
			component: () => import("@/components/attendance/EnrollmentCourse"),
			linkActiveClass: "active",
			meta: {
				title: "报学课程"
			}
		},
		{
			path: "/journalism_attendance_info",
			name: "JournalismAttendanceInfo",
			component: () => import("@/components/attendance/JournalismAttendanceInfo"),
			linkActiveClass: "active",
			meta: {
				title: "考勤信息"
			}
		},

		{
			path: "/enrollment_detail/:student_id/:service_id/:school_id",
			name: "EnrollmentDetail",
			component: () => import("@/components/attendance/EnrollmentDetail"),
			linkActiveClass: "active",
			meta: {
				title: "查看明细"
			}
		},
		// 报学课程 ------end

		// 缴费管理 ------start

		{
			path: "/look_handlePayment2",
			name: "LookHandlePayment2",
			component: () =>
				import("@/components/attendance/LookHandlePayment2"),
			linkActiveClass: "active",
			meta: {
				title: "查看缴费"
			}
		},

		{
			path: "/pay_management02",
			name: "PayManagement",
			component: () => import("@/components/attendance/PayManagement"),
			linkActiveClass: "active",
			meta: {
				title: "缴费管理"
			}
		},
		{
			path: "/handle_payment",
			name: "HandlePayment",
			component: () => import("@/components/attendance/HandlePayment"),
			linkActiveClass: "active",
			meta: {
				title: "办理缴费"
			}
		},

		{
			path: "/look_handle_payment/:handle_id",
			name: "LookHandlePayment",
			component: () =>
				import("@/components/attendance/LookHandlePayment"),
			linkActiveClass: "active",
			meta: {
				title: "查看缴费"
			}
		},
		{
			path: "/look_handle_invoice/:handle_id?",
			name: "LookPaymentInvoice",
			component: () =>
				import("@/components/attendance/LookPaymentInvoice"),
			linkActiveClass: "active",
			meta: {
				title: "缴费凭证"
			}
		},

		{
			path: "/todo_refund",
			name: "ToDoRefund",
			component: () => import("@/components/attendance/ToDoRefund"),
			linkActiveClass: "active",
			meta: {
				title: "办理退费"
			}
		},
		{
			path: "/look_refund/:handle_id?",
			name: "LookRefund",
			component: () => import("@/components/attendance/LookRefund"),
			linkActiveClass: "active",
			meta: {
				title: "查看退费"
			}
		},
		{
			path: "/look_refundInvoice/:handle_id?",
			name: "LookRefundInvoice",
			component: () =>
				import("@/components/attendance/LookRefundInvoice"),
			linkActiveClass: "active",
			meta: {
				title: "退费凭证"
			}
		},

		{
			path: "/todo_TransferCourse",
			name: "ToDoTransferCourse",
			component: () =>
				import("@/components/attendance/ToDoTransferCourse"),
			linkActiveClass: "active",
			meta: {
				title: "办理转课"
			}
		},
		{
			path: "/classEnding",
			name: "classEnding",
			component: () =>
				import("@/components/attendance/classEnding"),
			linkActiveClass: "active",
			meta: {
				title: "办理结课"
			}
		},
		{
			path: "/classEndingDetail",
			name: "classEndingDetail",
			component: () =>
				import("@/components/attendance/classEndingDetail"),
			linkActiveClass: "active",
			meta: {
				title: "查看结课"
			}
		},

		{
			path: "/look_TransferCourse/:handle_id?",
			name: "LookTransferCourse",
			component: () =>
				import("@/components/attendance/LookTransferCourse"),
			linkActiveClass: "active",
			meta: {
				title: "查看转课"
			}
		},
		{
			path: "/look_TransferCourseInvoice/:handle_id?",
			name: "LookTransferCourseInvoice",
			component: () =>
				import("@/components/attendance/LookTransferCourseInvoice"),
			linkActiveClass: "active",
			meta: {
				title: "转课凭证"
			}
		},

		// 缴费管理 ------end

		// 记考勤/查考勤/查点评 ------start
		{
			path: "/attendance_review",
			name: "AttendanceReview",
			component: () => import("@/components/attendance/AttendanceReview"),
			linkActiveClass: "active",
			meta: {
				title: "考勤点评"
			}
		},
		{
			path: "/attendance_stat_setting",
			name: "AttendanceStatSetting",
			component: () => import("@/components/attendance/AttendanceStatSetting"),
			linkActiveClass: "active",
			meta: {
				title: "出勤统计设置"
			}
		},
		{
			path: "/attendance_rule",
			name: "attendanceRule",
			component: () => import("@/components/attendance/attendanceRule"),
			linkActiveClass: "active",
			meta: {
				title: "考勤说明"
			}
		},

		{
			path: "/substitute_teacher",
			name: "substituteTeacher",
			component: () =>
				import("@/components/attendance/substituteTeacher"),
			linkActiveClass: "active",
			meta: {
				title: "代课班级考勤"
			}
		},
		{
			path: "/attendance_null",
			name: "AttendanceNull",
			component: () => import("@/components/attendance/AttendanceNull"),
			linkActiveClass: "active",
			meta: {
				title: "未点评"
			}
		},
		{
			path: "/record_attendance/:class_id",
			name: "RecordAttendance",
			component: () => import("@/components/attendance/RecordAttendance"),
			linkActiveClass: "active",
			meta: {
				title: "记考勤"
			}
		},

		{
			path: "/attendanceStudent",
			name: "attendanceStudent",
			component: () => import("@/components/attendance/attendanceStudent"),
			linkActiveClass: "active",
			meta: {
				title: "学员列表"
			}
		},
		{
			path: "/singlePersonAttendance/:studentId",
			name: "singlePersonAttendance",
			component: () => import("@/components/attendance/singlePersonAttendance"),
			linkActiveClass: "active",
			meta: {
				title: "单个学员考勤"
			}
		},

		{
			path: "/record_attendanceEdit/:id/:class_id",
			name: "RecordAttendanceEdit",
			component: () =>
				import("@/components/attendance/RecordAttendanceEdit"),
			linkActiveClass: "active",
			meta: {
				title: "修改考勤"
			}
		},
		{
			path: "/record_attendanceDetail/:id/:startDay?/:endDay?/:teacherId?",
			name: "RecordAttendanceDetail",
			component: () =>
				import("@/components/attendance/RecordAttendanceDetail"),
			linkActiveClass: "active",
			meta: {
				title: "考勤记录"
			}
		},
		{
			path: "/attendance_uploadWorks/:id",
			name: "AttendanceUploadWorks",
			component: () =>
				import("@/components/attendance/AttendanceUploadWorks"),
			linkActiveClass: "active",
			meta: {
				title: "上传作品"
			}
		},
		{
			path: "/attendance_classStatistics",
			name: "AttendanceClassStatistics",
			component: () =>
				import("@/components/attendance/AttendanceClassStatistics"),
			linkActiveClass: "active",
			meta: {
				title: "班级统计"
			}
		},
		{
			path: "/studentProfile/:id",
			name: "studentProfile",
			component: () =>
				import("@/components/attendance/studentProfile"),
			linkActiveClass: "active",
			meta: {
				title: "学员档案记录"
			}
		},
		{
			path: "/attendance_studentSearch",
			name: "AttendanceStudentSearch",
			component: () =>
				import("@/components/attendance/AttendanceStudentSearch"),
			linkActiveClass: "active",
			meta: {
				title: "学员查询"
			}
		},
		{
			path: "/attendance_studentDetail",
			name: "AttendanceStudentDetail",
			component: () =>
				import("@/components/attendance/AttendanceStudentDetail"),
			linkActiveClass: "active",
			meta: {
				title: "学员详情"
			},
		},

		{
			path: "/record_attendanceDetail_id/:id",
			name: "RecordAttendanceDetailId",
			component: () =>
				import("@/components/attendance/RecordAttendanceDetail"),
			linkActiveClass: "active",
			meta: {
				title: "考勤记录"
			}
		},

		{
			path: "/attendance_workList",
			name: "AttendanceWorkList",
			component: () =>
				import("@/components/attendance/AttendanceWorkList"),
			linkActiveClass: "active",
			meta: {
				title: "作品列表"
			}
		},



		{
			path: "/attendance_workDetail",
			name: "AttendanceWorkDetail",
			component: () =>
				import("@/components/attendance/AttendanceWorkDetail"),
			linkActiveClass: "active",
			meta: {
				title: "作品信息"
			}
		},
		{
			path: "/attendance_workEdit",
			name: "AttendanceWorkEdit",
			component: () =>
				import("@/components/attendance/AttendanceWorkEdit"),
			linkActiveClass: "active",
			meta: {
				title: "修改作品信息"
			}
		},

		// 记考勤/查考勤/查点评 ------end

		// 考勤缴费管理
		// =============end================

		// 拼团模块
		// =============start================
		// 拼团商品页
		{
			path: "/goods_detail/:id/:spell_id?",
			name: "goodsDetail",
			component: () => import("@/pages/spellGroup/GoodsDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团课详情"
			}
		},
		{
			path: "/rolls_detail/:id/:spell_id?",
			name: "rollsDetail",
			component: () => import("@/pages/spellRoll/GoodsDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团券详情"
			}
		},
		// 相关支付页面
		{
			path: "/spell_pay/:id/:type/:spell_id?",
			name: "spellPay",
			component: () => import("@/pages/spellGroup/Pay.vue"),
			linkActiveClass: "active",
			meta: {
				title: "画宝汇"
			}
		},
		{
			path: "/roll_pay/:id/:type/:spell_id?",
			name: "rollPay",
			component: () => import("@/pages/spellRoll/Pay.vue"),
			linkActiveClass: "active",
			meta: {
				title: "画宝汇"
			}
		},
		// 拼团家长端 ------ start
		{
			path: "/spell_parents_list",
			name: "spell_parents_list",
			component: () => import("@/pages/spellGroup/parents/List.vue"),
			linkActiveClass: "active",
			meta: {
				title: "我的拼团"
			}
		},
		{
			path: "/order_details/:id",
			name: "order_details",
			component: () =>
				import("@/pages/spellGroup/parents/OrderDetails.vue"),
			linkActiveClass: "active",
			meta: {
				title: "购买成功"
			}
		},
		// 拼团家长端------end

		// 拼团教师端------start

		{
			path: "/spell_teacher_list",
			name: "spellTeacherList",
			component: () => import("@/pages/spellGroup/principal/List.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团招生"
			}
		},
		{
			path: "/spell_teacher_order/:id",
			name: "spellTeacherOrder",
			component: () =>
				import("@/pages/spellGroup/teacher/OrderDetails.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团详情"
			}
		},
		{
			path: "/noPermission",
			name: "noPermission",
			component: () =>
				import("@/pages/spellGroup/teacher/noPermission.vue"),
			linkActiveClass: "active",
			meta: {
				title: "暂无权限"
			}
		},
		{
			path: "/spell_teacher_state/:id/:type",
			name: "spellTeacherState",
			component: () =>
				import("@/pages/spellGroup/teacher/ScanCodeState.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团详情"
			}
		},

		// 拼团教师端------end

		// 拼团馆长端------start
		{
			path: "/spell_principal_list",
			name: "spellPrincipalList",
			component: () =>
				import("@/pages/spellGroup/principal/List.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团招生"
			}
		},
		{
			path: "/spell_principal_order/:id",
			name: "spellPrincipalOrder",
			component: () =>
				import("@/pages/spellGroup/principal/OrderDetails.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团详情"
			}
		},
		{
			path: "/tuiKuan/:id",
			name: "tuiKuan",
			component: () =>
				import("@/pages/spellGroup/principal/tuiKuan.vue"),
			linkActiveClass: "active",
			meta: {
				title: "退款详情"
			}
		},
		{
			path: "/spell_create",
			name: "spellCreate",
			component: () =>
				import("@/pages/spellGroup/principal/Create.vue"),
			linkActiveClass: "active",
			meta: {
				title: "发布拼团"
			}
		},
		{
			path: "/spell_edit/:id",
			name: "spellEditx",
			component: () =>
				import("@/pages/spellGroup/principal/Edit.vue"),
			linkActiveClass: "active",
			meta: {
				title: "修改拼团"
			}
		},
		{
			path: "/template_detail/:type/:id?",
			name: "templateDetail",
			component: () =>
				import("@/pages/spellGroup/templateDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "预览拼团课"
			}
		},
		{
			path: "/fangAn",
			name: "fangAn",
			component: () =>
				import("@/pages/spellGroup/fangAn.vue"),
			linkActiveClass: "active",
			meta: {
				title: "方案展示"
			}
		},
		{
			path: "/verification_run",
			name: "verificationRun",
			component: () =>
				import("@/pages/spellGroup/verificationRun.vue"),
			linkActiveClass: "active",
			meta: {
				title: "核销中"
			}
		},

		// 劵
		//拼卷家长端 ------ start
		{
			path: "/roll_parents_list",
			name: "roll_parents_list",
			component: () => import("@/pages/spellRoll/parents/List.vue"),
			linkActiveClass: "active",
			meta: {
				title: "我的拼团"
			}
		},
		{
			path: "/roll_order_details/:id",
			name: "roll_order_details",
			component: () =>
				import("@/pages/spellRoll/parents/OrderDetails.vue"),
			linkActiveClass: "active",
			meta: {
				title: "购买成功"
			}
		},

		{
			path: "/spellFoot/:type/:id",
			name: "spellFoot",
			component: () =>
				import("@/pages/spellGroup/spellFoot.vue"),
			linkActiveClass: "active",
			meta: {
				title: "结算详情"
			}
		},
		// 拼团家长端------end

		// 拼团教师端------start

		{
			path: "/roll_spell_teacher_list",
			name: "rollTeacherList",
			component: () => import("@/pages/spellRoll/principal/List.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团招生"
			}
		},
		{
			path: "/roll_teacher_order/:id",
			name: "rollTeacherOrder",
			component: () =>
				import("@/pages/spellRoll/teacher/OrderDetails.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团详情"
			}
		},
		{
			path: "/roll_teacher_state/:id/:type",
			name: "rollTeacherState",
			component: () =>
				import("@/pages/spellRoll/teacher/ScanCodeState.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼券详情"
			}
		},

		// 拼团教师端------end

		// 拼团馆长端------start
		{
			path: "/roll_principal_list",
			name: "rollPrincipalList",
			component: () =>
				import("@/pages/spellRoll/principal/List.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼团招生"
			}
		},
		{
			path: "/roll_principal_order/:id",
			name: "rollPrincipalOrder",
			component: () =>
				import("@/pages/spellRoll/principal/OrderDetails.vue"),
			linkActiveClass: "active",
			meta: {
				title: "拼券详情"
			}
		},
		{
			path: "/roll_create",
			name: "rollCreate",
			component: () =>
				import("@/pages/spellRoll/principal/Create.vue"),
			linkActiveClass: "active",
			meta: {
				title: "发布拼券"
			}
		},
		{
			path: "/roll_edit/:id",
			name: "rollEdit",
			component: () =>
				import("@/pages/spellRoll/principal/Edit.vue"),
			linkActiveClass: "active",
			meta: {
				title: "修改拼券"
			}
		},
		{
			path: "/roll_template_detail/:type/:id?",
			name: "rollTemplateDetail",
			component: () =>
				import("@/pages/spellRoll/templateDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "预览拼团券"
			}
		},

		{
			path: "/roll_verification_run",
			name: "roll_verificationRun",
			component: () =>
				import("@/pages/spellRoll/verificationRun.vue"),
			linkActiveClass: "active",
			meta: {
				title: "核销中"
			}
		},
		{
			path: "/buyService",
			name: "buyService",
			component: () =>
				import("@/components/service/buyService.vue"),
			linkActiveClass: "active",
			meta: {
				title: "购买合作"
			}
		},
		{
			path: "/servicePayment/:id",
			name: "servicePayment",
			component: () =>
				import("@/components/service/servicePayment.vue"),
			linkActiveClass: "active",
			meta: {
				title: "购买家长合伙人"
			}
		},
		{
			path: "/orderDetails1",
			name: "orderDetails",
			component: () =>
				import("@/components/service/orderDetails.vue"),
			linkActiveClass: "active",
			meta: {
				title: "购买合作"
			}

		},
		{
			path: "/verifyDetail/:id",
			name: "verifyDetail",
			component: () =>
				import("@/components/service/verifyDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "家长合伙人福利核销"
			}
		},
		{
			path: "/friend_card/:id",
			name: "friendCard",
			component: () =>
				import("@/components/service/friendCard.vue"),
			linkActiveClass: "active",
			meta: {
				title: "好友卡"
			}

		},

		{
			path: "/jianHua",
			name: "jianHua",
			component: () =>
				import("@/components/service/jianHua.vue"),
			linkActiveClass: "active",
			meta: {
				title: "家长合伙人"
			}
		},
		{
			path: "/serviceContent",
			name: "serviceContent",
			component: () =>
				import("@/components/service/serviceContent.vue"),
			linkActiveClass: "active",
			meta: {
				title: "家长合伙人"
			}
		},
		{
			path: "/setStudentDiscounts",
			name: "setStudentDiscounts",
			component: () =>
				import("@/components/service/setStudentDiscounts.vue"),
			linkActiveClass: "active",
			meta: {
				title: "设置学员优惠"
			}
		},
		{
			path: "/addStudentDiscount",
			name: "addStudentDiscount",
			component: () =>
				import("@/components/service/addStudentDiscount.vue"),
			linkActiveClass: "active",
			meta: {
				title: "新增优惠学员"
			}
		},
		{
			path: "/addService/:id?",
			name: "addService",
			component: () =>
				import("@/components/service/addService.vue"),
			linkActiveClass: "active",
			meta: {
				title: "新建家长合伙人"
			}
		},
		{
			path: "/service_mould/:id",
			name: "serviceMould",
			component: () =>
				import("@/components/service/serviceMould.vue"),
			linkActiveClass: "active",
			meta: {
				title: "合作模板"
			}
		},
		{
			path: "/editService",
			name: "editService",
			component: () =>
				import("@/components/service/addService.vue"),
			linkActiveClass: "active",
			meta: {
				title: "修改家长合伙人"
			}
		},
		{
			path: "/jieSuan",
			name: "jieSuan",
			component: () =>
				import("@/components/service/jieSuan.vue"),
			linkActiveClass: "active",
			meta: {
				title: "家长合伙人结算"
			}
		},
		{
			path: "/jieSuans",
			name: "jieSuans",
			component: () =>
				import("@/components/service/jieSuans.vue"),
			linkActiveClass: "active",
			meta: {
				title: "申请结算"
			}
		},
		{
			path: "/jieSuanz",
			name: "jieSuanz",
			component: () =>
				import("@/components/service/jieSuanz.vue"),
			linkActiveClass: "active",
			meta: {
				title: "结算中"
			}
		},
		{
			path: "/jieSuanw",
			name: "jieSuanw",
			component: () =>
				import("@/components/service/jieSuanw.vue"),
			linkActiveClass: "active",
			meta: {
				title: "订单结算"
			}
		},
		{
			path: "/pingZheng",
			name: "pingZheng",
			component: () =>
				import("@/components/service/pingZheng.vue"),
			linkActiveClass: "active",
			meta: {
				title: "凭证"
			}
		},
		{
			path: "/jiGou/:school_id?/:parent_id?",
			name: "jiGou",
			component: () =>
				import("@/components/jigou/jiGou.vue"),
			linkActiveClass: "active",
			meta: {
				title: "机构",
				keepAlive: true
			}
		},
		{
			path: "/introduction/:active(\\d+)?",
			name: "introduction",
			component: () =>
				import("@/components/introduction/index.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课程卡转介绍",
				keepAlive: true
			}
		},
		{
			path: "/introduction/roster/:id/:type",
			name: "introductionRoster",
			component: () =>
				import("@/components/introduction/roster.vue"),
			linkActiveClass: "active",
			meta: {
				title: "转介绍名单",
				keepAlive: true
			}
		},
		{
			path: "/introduction/settlement/:id/:active?",
			name: "introductionSettlement",
			component: () =>
				import("@/components/introduction/settlement.vue"),
			linkActiveClass: "active",
			meta: {
				title: "转介绍结算",
				keepAlive: true
			}
		},
		{
			path: "/introduction/submitSettlement/:id",
			name: "submitSettlement",
			component: () =>
				import("@/components/introduction/submitSettlement.vue"),
			linkActiveClass: "active",
			meta: {
				title: "确认结算",
				keepAlive: true
			}
		},

		{
			path: "/introduction/inSettlement/:id",
			name: "introductionInSettlement",
			component: () =>
				import("@/components/introduction/inSettlement.vue"),
			linkActiveClass: "active",
			meta: {
				title: "结算中",
				keepAlive: true
			}
		},
		{
			path: "/introduction/settled/:id",
			name: "introductionSettled",
			component: () =>
				import("@/components/introduction/settled.vue"),
			linkActiveClass: "active",
			meta: {
				title: "已结算",
				keepAlive: true
			}
		},
		{
			path: "/introduction/mould/:id",
			name: "introductionMould",
			component: () =>
				import("@/components/introduction/mould.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课程卡模板",
				keepAlive: true
			}
		},
		{
			path: "/introduction/edit/:id?",
			name: "introductionEdit",
			component: () =>
				import("@/components/introduction/edit.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课程卡转介绍",
				keepAlive: true
			}
		},
		{
			path: "/introduction/detail/:id/:shareUserId?",
			name: "introductionDetail",
			component: () =>
				import("@/components/introduction/detail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课程卡转介绍",
				keepAlive: true
			}
		},
		{
			path: "/introduction/invitation/:id",
			name: "introductionInvitation",
			component: () =>
				import("@/components/introduction/invitation.vue"),
			linkActiveClass: "active",
			meta: {
				title: "学员课程卡转介绍",
				keepAlive: true
			}
		},
		{
			path: "/introduction/help/:id",
			name: "introductionHelp",
			component: () =>
				import("@/components/introduction/help.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课程卡助力",
				keepAlive: true
			}
		},
		{
			path: "/introduction/verify/:id",
			name: "introductionVerify",
			component: () =>
				import("@/components/introduction/verify.vue"),
			linkActiveClass: "active",
			meta: {
				title: "转介绍核销",
				keepAlive: true
			}
		},


		{
			path: "/principal_report",
			name: "principalReport",
			component: () =>
				import("@/components/jigou/principalReport.vue"),
			linkActiveClass: "active",
			meta: {
				title: "校长报表",
				keepAlive: true
			}
		},
		{
			path: "/notice",
			name: "notice",
			component: () =>
				import("@/components/jigou/notice.vue"),
			linkActiveClass: "active",
			meta: {
				title: "服务通知",
				keepAlive: true
			}
		},
		{
			path: "/notice/detail/:id",
			name: "noticeDetail",
			component: () =>
				import("@/components/jigou/noticeDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "服务通知详情",
				keepAlive: true
			}
		},

		{
			path: "/shokey_code",
			name: "shokeyCode",
			component: () =>
				import("@/components/jigou/shokeyCode.vue"),
			linkActiveClass: "active",
			meta: {
				title: "试课码",
				keepAlive: true
			}
		},
		{
			path: "/auditionGift/:school_id",
			name: "auditionGift",
			component: () =>
				import("@/components/jigou/auditionGift.vue"),
			linkActiveClass: "active",
			meta: {
				title: "学员试听",
				keepAlive: true
			}
		},

		{
			path: "/brand_story/:id",
			name: "brandStory",
			component: () =>
				import("@/components/jigou/brandStory.vue"),
			linkActiveClass: "active",
			meta: {
				title: "品牌故事",
				keepAlive: true
			}
		},
		{
			path: "/brand_story_detail/:id",
			name: "brandStoryDetail",
			component: () =>
				import("@/components/jigou/brandStoryDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "品牌故事",
				keepAlive: true
			}
		},
		{
			path: "/student_recommend",
			name: "studentRecommend",
			component: () =>
				import("@/components/jigou/studentRecommend.vue"),
			linkActiveClass: "active",
			meta: {
				title: "话廊推荐至首页",
				keepAlive: true
			}
		},
		{
			path: "/works_recommend",
			name: "worksRecommend",
			component: () =>
				import("@/components/jigou/worksRecommend.vue"),
			linkActiveClass: "active",
			meta: {
				title: "作品推荐至首页",
				keepAlive: true
			}
		},
		{
			path: "/teacherListj",
			name: "teacherListj",
			component: () =>
				import("@/components/jigou/teacherList.vue"),
			linkActiveClass: "active",
			meta: {
				title: "教师荣誉榜单",
				keepAlive: true
			}
		},

		{
			path: "/teacherCreate",
			name: "teacherCreate",
			component: () =>
				import("@/components/jigou/teacherCreate.vue"),
			linkActiveClass: "active",
			meta: {
				title: "教师创收",
				keepAlive: true
			}
		},
		{
			path: "/dingzhi",
			name: "dingZhi",
			component: () =>
				import("@/components/jigou/dingZhi.vue"),
			linkActiveClass: "active",
			meta: {
				title: "联盟招生定制",
				keepAlive: true
			}
		},
		{
			path: "/dabang",
			name: "daBang",
			component: () =>
				import("@/components/jigou/daBang.vue"),
			linkActiveClass: "active",
			meta: {
				title: "人气打榜"
			}
		},
		{
			path: "/dabangj",
			name: "daBangJ",
			component: () =>
				import("@/components/jigou/daBangJ.vue"),
			linkActiveClass: "active",
			meta: {
				title: "新建打榜"
			}
		},
		{
			path: "/dabangc",
			name: "daBangC",
			component: () =>
				import("@/components/jigou/daBangC.vue"),
			linkActiveClass: "active",
			meta: {
				title: "打榜信息"
			}
		},
		{
			path: "/zhanLan/:school_id?",
			name: "zhanLan",
			component: () =>
				import("@/components/jigou/zhanLan.vue"),
			linkActiveClass: "active",
			meta: {
				title: "展览中心"
			}
		},
		// {
		//     path: "/fuJin",
		//     name: "fuJin",
		//     component: () =>
		//         import("@/components/jigou/fuJin.vue"),
		//     linkActiveClass: "active",
		//     meta: {
		//         title: "附近机构"
		//     }
		// },
		{
			path: "/woDe",
			name: "woDe",
			component: () =>
				import("@/components/wode/woDe.vue"),
			linkActiveClass: "active",
			meta: {
				title: "个人中心"
			}
		},
		{
			path: "/sheZhi",
			name: "sheZhi",
			component: () =>
				import("@/components/wode/sheZhi.vue"),
			linkActiveClass: "active",
			meta: {
				title: "个人中心"
			}
		},
		{
			path: "/pingZheng1",
			name: "pingZheng1",
			component: () =>
				import("@/pages/feeManagement/pingZheng"),
			linkActiveClass: "active",
			meta: {
				title: "凭证"
			}
		},
		{
			path: "/giveProof/:id",
			name: "giveProof",
			component: () =>
				import("@/pages/feeManagement/giveProof"),
			linkActiveClass: "active",
			meta: {
				title: "凭证"
			}
		},

		{
			path: "/zuoPin",
			name: "zuoPin",
			component: () =>
				import("@/components/hualang/zuoPin"),
			linkActiveClass: "active",
			meta: {
				title: "课堂作品"
			}
		},
		{
			path: "/wuKe",
			name: "wuKe",
			component: () =>
				import("@/pages/onlineCourse/wuKe"),
			linkActiveClass: "active",
			meta: {
				title: "线上课程"
			}
		},
		{
			path: "/popularize/:popularizeId/:shareUserId?",
			name: "tuiGuang",
			component: () =>
				import("@/components/public/tuiGuang"),
			linkActiveClass: "active",
			meta: {
				title: "免费学"
			}
		},
		{
			path: "/profit",
			name: "profit",
			component: () =>
				import("@/components/huabao/profit"),
			linkActiveClass: "active",
			meta: {
				title: "画宝收益"
			}
		},
		{
			path: "/overalList",
			name: "overalList",
			component: () =>
				import("@/components/huabao/overalList"),
			linkActiveClass: "active",
			meta: {
				title: "总榜单"
			}
		},
		{
			path: "/detailed",
			name: "detailed",
			component: () =>
				import("@/components/huabao/detailed"),
			linkActiveClass: "active",
			meta: {
				title: "画宝收益明细"
			}
		},
		{
			path: "/detailedDetail",
			name: "detailedDetail",
			component: () =>
				import("@/components/huabao/detailedDetail"),
			linkActiveClass: "active",
			meta: {
				title: "画宝收益详情"
			}
		},
		{
			path: "/eventManagement",
			name: "eventManagement",
			component: () =>
				import("@/components/spellGroup/eventManagement"),
			linkActiveClass: "active",
			meta: {
				title: "活动管理"
			}
		},
		{
			path: "/settlement",
			name: "Settlement",
			component: () =>
				import("@/components/spellGroup/settlement.vue"),
			// import("@/components/spellGroup/eventManagement"),
			linkActiveClass: "active",
			meta: {
				title: "机构活动核销",
				keepAlive: true
			}
		},
		{
			path: "/partnerPromotion",
			name: "PartnerPromotion",
			component: () =>
				import("@/components/spellGroup/partnerPromotion.vue"),
			linkActiveClass: "active",
			meta: {
				title: "合作商推广员"
			}
		},
		{
			path: "/registrationAutomaticallyAdd",
			name: "RegistrationAutomaticallyAdd",
			component: () =>
				import("@/components/spellGroup/registrationAutomaticallyAdd.vue"),
			linkActiveClass: "active",
			meta: {
				title: "报名自动添加为推广员"
			}
		},
		{
			path: "/batchImportAndClaim",
			name: "batchImportAndClaim",
			component: () =>
				import("@/components/spellGroup/batchImportAndClaim.vue"),
			linkActiveClass: "active",
			meta: {
				title: "批量导入领取"
			}
		},
		{
			path: "/batchImportOnly",
			name: "batchImportOnly",
			component: () =>
				import("@/components/spellGroup/batchImportOnly.vue"),
			linkActiveClass: "active",
			meta: {
				title: "批量导入"
			}
		},
		{
			path: "/batchDeleteOnly",
			name: "batchDeleteOnly",
			component: () =>
				import("@/components/spellGroup/batchDeleteOnly.vue"),
			linkActiveClass: "active",
			meta: {
				title: "批量删除"
			}
		},
		{
			path: "/claimToBePromoter",
			name: "claimToBePromoter",
			component: () =>
				import("@/components/spellGroup/claimToBePromoter.vue"),
			linkActiveClass: "active",
			meta: {
				title: "领取推广员"
			}
		},
		{
			path: "/registrationAutomaticallyModify",
			name: "RegistrationAutomaticallyModify",
			component: () =>
				import("@/components/spellGroup/registrationAutomaticallyModify.vue"),
			linkActiveClass: "active",
			meta: {
				title: "报名自动添加为推广员" // 修改页面
			}
		},
		{
			path: "/liveOrder",
			name: "LiveOrder",
			component: () =>
				import("@/components/spellGroup/liveOrder.vue"),
			linkActiveClass: "active",
			meta: {
				title: "直播间入口"
			}
		},
		{
			path: "/liveDetail/:id",
			name: "liveDetail",
			component: () =>
				import("@/components/spellGroup/liveDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "直播间入口"
			}
		},
		// {
		//     path: "/liveEntry",
		//     name: "LiveEntry",
		//     component: () =>
		//         import("@/components/spellGroup/liveEntry.vue"),
		//     linkActiveClass: "active",
		//     meta: {
		//         title: "超级话廊直播"
		//     }
		// }
		,
		{
			path: "/spellMould",
			name: "spellMould",
			component: () =>
				import("@/components/spellGroup/spell/spellMould"),
			linkActiveClass: "active",
			meta: {
				title: "拼团模板"
			}
		},
		{
			path: "/spellPreview",
			name: "spellPreview",
			component: () =>
				import("@/components/spellGroup/spell/spellPreview"),
			linkActiveClass: "active",
			meta: {
				title: "预览拼团"
			}
		},
		{
			path: "/spellEdit",
			name: "spellEdit",
			component: () =>
				import("@/components/spellGroup/spell/spellEdit"),
			linkActiveClass: "active",
			meta: {
				title: "拼团编辑"
			}
		},
		{
			path: "/spellAdd",
			name: "spellAdd",
			component: () =>
				import("@/components/spellGroup/spell/spellEdit"),
			linkActiveClass: "active",
			meta: {
				title: "新建拼团"
			}
		},
		{
			path: "/spellRoster",
			name: "spellRoster",
			component: () =>
				import("@/components/spellGroup/spell/spellRoster"),
			linkActiveClass: "active",
			meta: {
				title: "拼团名单"
			}
		}

		,
		{
			path: "/spellRosterSettlement",
			name: "spellRosterSettlement",
			component: () =>
				import("@/components/spellGroup/spell/spellRosterSettlement"),
			linkActiveClass: "active",
			meta: {
				title: "拼团名单"
			}
		},
		{
			path: "/spellSettlement",
			name: "spellSettlement",
			component: () =>
				import("@/components/spellGroup/spell/spellSettlement"),
			linkActiveClass: "active",
			meta: {
				title: "确认结算"
			}
		},
		{
			path: "/settlementDetail",
			name: "settlementDetail",
			component: () =>
				import("@/components/spellGroup/spell/settlementDetail"),
			linkActiveClass: "active",
			meta: {
				title: "结算详情"
			}
		},
		{
			path: "/spellDetail",
			name: "spellDetail",
			component: () =>
				import("@/components/spellGroup/spell/spellDetail"),
			linkActiveClass: "active",
			meta: {
				title: "订单详情"
			}
		},
		{
			path: "/commodityDetail",
			name: "commodityDetail",
			component: () =>
				import("@/components/spellGroup/spell/commodityDetail"),
			linkActiveClass: "active",
			meta: {
				title: "商品详情"
			}
		},
		{
			path: "/eventPurchase",
			name: "eventPurchase",
			component: () =>
				import("@/components/spellGroup/spell/eventPurchase"),
			linkActiveClass: "active",
			meta: {
				title: "活动购买"
			}
		},
		{
			path: "/friendToPay",
			name: "FriendToPay",
			component: () =>
				import("@/components/spellGroup/spell/friendToPay"),
			linkActiveClass: "active",
			meta: {
				title: "好友代付"
			}
		},
		{
			path: "/spellBuy",
			name: "spellBuy",
			component: () =>
				import("@/components/spellGroup/spell/spellBuy"),
			linkActiveClass: "active",
			meta: {
				title: "拼团活动"
			}
		},
		{
			path: "/spellBuy1", // 备用地址
			name: "spellBuy1",
			component: () =>
				import("@/components/spellGroup/spell/spellBuy"),
			linkActiveClass: "active",
			meta: {
				title: "拼团活动"
			}
		},
		{
			path: "/courseEntryList",
			name: "CourseEntryList",
			component: () =>
				import("@/components/spellGroup/courseEntryList"),
			linkActiveClass: "active",
			meta: {
				title: "课程入口"
			}
		},
		{
			path: "/goldPlanReceipt",
			name: "goldPlanReceipt",
			component: () =>
				import("@/components/order/goldPlanReceipt"),
			linkActiveClass: "active",
			meta: {
				title: "支付成功"
			}
		},
		{
			path: "/spellOrder",
			name: "spellOrder",
			component: () =>
				import("@/components/spellGroup/spell/spellOrder"),
			linkActiveClass: "active",
			meta: {
				title: "活动订单"
			}
		},
		{
			path: "/myPromotion",
			name: "myPromotion",
			component: () =>
				import("@/components/spellGroup/myPromotion"),
			linkActiveClass: "active",
			meta: {
				title: "我的推广"
			}
		},
		{
			path: "/spellOrderDetail",
			name: "spellOrderDetail",
			component: () =>
				import("@/components/spellGroup/spell/spellOrderDetail"),
			linkActiveClass: "active",
			meta: {
				title: "活动订单详情"
			}
		},
		{
			path: "/spellLotteryDraw",
			name: "spellLotteryDraw",
			component: () =>
				import("@/components/spellGroup/spell/spellLotteryDraw"),
			linkActiveClass: "active",
			meta: {
				title: "拼团抽奖"
			}
		},
		{
			path: "/prizeMould",
			name: "prizeMould",
			component: () =>
				import("@/components/spellGroup/prize/prizeMould"),
			linkActiveClass: "active",
			meta: {
				title: "抽奖模板"
			}
		},
		{
			path: "/prizePreview",
			name: "prizePreview",
			component: () =>
				import("@/components/spellGroup/prize/prizePreview"),
			linkActiveClass: "active",
			meta: {
				title: "预览抽奖"
			}
		},
		{
			path: "/prizeEdit",
			name: "prizeEdit",
			component: () =>
				import("@/components/spellGroup/prize/prizeEdit"),
			linkActiveClass: "active",
			meta: {
				title: "抽奖编辑"
			}
		},
		{
			path: "/prizeAdd",
			name: "prizeAdd",
			component: () =>
				import("@/components/spellGroup/prize/prizeEdit"),
			linkActiveClass: "active",
			meta: {
				title: "新建抽奖"
			}
		},
		{
			path: "/prizeRoster",
			name: "prizeRoster",
			component: () =>
				import("@/components/spellGroup/prize/prizeRoster"),
			linkActiveClass: "active",
			meta: {
				title: "抽奖名单"
			}
		},
		{
			path: "/prizeOrderDetail",
			name: "prizeOrderDetail",
			component: () =>
				import("@/components/spellGroup/prize/prizeOrderDetail"),
			linkActiveClass: "active",
			meta: {
				title: "活动订单详情"
			}
		},
		{
			path: "/prizeDetail",
			name: "prizeDetail",
			component: () =>
				import("@/components/spellGroup/prize/prizeDetail"),
			linkActiveClass: "active",
			meta: {
				title: "抽奖详情"
			}
		},
		{
			path: "/prizeDraw",
			name: "prizeDraw",
			component: () =>
				import("@/components/spellGroup/prize/prizeDraw"),
			linkActiveClass: "active",
			meta: {
				title: "抽奖活动"
			}
		},
		{
			path: "/prizeDraw1",
			name: "prizeDraw1",
			component: () =>
				import("@/components/spellGroup/prize/prizeDraw"),
			linkActiveClass: "active",
			meta: {
				title: "抽奖活动"
			}
		},
		{
			path: "/entryMould",
			name: "entryMould",
			component: () =>
				import("@/components/spellGroup/entry/entryMould"),
			linkActiveClass: "active",
			meta: {
				title: "报名模板"
			}
		},
		{
			path: "/entryPreview",
			name: "entryPreview",
			component: () =>
				import("@/components/spellGroup/entry/entryPreview"),
			linkActiveClass: "active",
			meta: {
				title: "预览报名"
			}
		},
		{
			path: "/entryRecruitCardMap",
			name: "entryRecruitCardMap",
			component: () =>
				import("@/components/spellGroup/entry/entryRecruitCardMap"),
			linkActiveClass: "active",
			meta: {
				title: "一卡通"
			}
		},
		{
			path: "/entryRecruitCardGrantDetail",
			name: "entryRecruitCardGrantDetail",
			component: () =>
				import("@/components/spellGroup/entry/entryRecruitCardGrantDetail"),
			linkActiveClass: "active",
			meta: {
				title: "一卡通"
			}
		},
		{
			path: "/entryRecruitCardParticipating",
			name: "entryRecruitCardParticipating",
			component: () =>
				import("@/components/spellGroup/entry/entryRecruitCardParticipating"),
			linkActiveClass: "active",
			meta: {
				title: "一卡通"
			}
		},
		{
			path: "/entryRecruitCardQrInvalid",
			name: "entryRecruitCardQrInvalid",
			component: () =>
				import("@/components/spellGroup/entry/entryRecruitCardQrInvalid"),
			linkActiveClass: "active",
			meta: {
				title: "提示"
			}
		},
		{
			path: "/entryRecruitCardVerify",
			name: "entryRecruitCardVerify",
			component: () =>
				import("@/components/spellGroup/entry/entryRecruitCardVerify"),
			linkActiveClass: "active",
			meta: {
				title: "一卡通核销"
			}
		},
		{
			path: "/entryRecruitCardVerifyLog",
			name: "entryRecruitCardVerifyLog",
			component: () =>
				import("@/components/spellGroup/entry/entryRecruitCardVerifyLog"),
			linkActiveClass: "active",
			meta: {
				title: "核销信息"
			}
		},
		{
			path: "/entryEdit",
			name: "entryEdit",
			component: () =>
				import("@/components/spellGroup/entry/entryEdit"),
			linkActiveClass: "active",
			meta: {
				title: "报名编辑"
			}
		},
		{
			path: "/entryAdd",
			name: "entryAdd",
			component: () =>
				import("@/components/spellGroup/entry/entryEdit"),
			linkActiveClass: "active",
			meta: {
				title: "新建报名"
			}
		},
		{
			path: "/entryRoster",
			name: "entryRoster",
			component: () =>
				import("@/components/spellGroup/entry/entryRoster"),
			linkActiveClass: "active",
			meta: {
				title: "报名名单"
			}
		},
		{
			path: "/entryRosterSettlement",
			name: "entryRosterSettlement",
			component: () =>
				import("@/components/spellGroup/entry/entryRosterSettlement"),
			linkActiveClass: "active",
			meta: {
				title: "报名名单"
			}
		},
		{
			path: "/entryHuifuBankCert",
			name: "entryHuifuBankCert",
			component: () =>
				import("@/components/spellGroup/entry/entryHuifuBankCert"),
			linkActiveClass: "active",
			meta: {
				title: "银行卡认证"
			}
		},
		{
			path: "/entryHuifuEntModify",
			name: "entryHuifuEntModify",
			component: () =>
				import("@/components/spellGroup/entry/entryHuifuEntModify"),
			linkActiveClass: "active",
			meta: {
				title: "企业信息修改"
			}
		},
		{
			path: "/entryHuifuBankModify",
			name: "entryHuifuBankModify",
			component: () =>
				import("@/components/spellGroup/entry/entryHuifuBankModify"),
			linkActiveClass: "active",
			meta: {
				title: "银行卡修改"
			}
		},
		{
			path: "/entrySettlement",
			name: "entrySettlement",
			component: () =>
				import("@/components/spellGroup/entry/entrySettlement"),
			linkActiveClass: "active",
			meta: {
				title: "确认结算"
			}
		},
		{
			path: "/settlementDetailE",
			name: "settlementDetailE",
			component: () =>
				import("@/components/spellGroup/entry/settlementDetail"),
			linkActiveClass: "active",
			meta: {
				title: "结算详情"
			}
		},
		{
			path: "/entryDetail",
			name: "entryDetail",
			component: () =>
				import("@/components/spellGroup/entry/entryDetail"),
			linkActiveClass: "active",
			meta: {
				title: "订单详情"
			}
		}

		,
		{
			path: "/assessment/orgList",
			name: "assessmentOrgList",
			component: () =>
				import("@/components/assessment/orgList"),
			linkActiveClass: "active",
			meta: {
				title: "官方测评"
			}
		},
		{
			path: "/assessment/orgDetail",
			name: "assessmentOrgDetail",
			component: () =>
				import("@/components/assessment/orgDetail"),
			linkActiveClass: "active",
			meta: {
				title: "官方测评报名系统-机构端"
			}
		},
		{
			path: "/assessment/orgManage",
			name: "assessmentOrgManage",
			component: () =>
				import("@/components/assessment/orgManage"),
			linkActiveClass: "active",
			meta: {
				title: "家长报名测评记录"
			}
		},
		{
			path: "/assessment/orgEnrollmentDetail",
			name: "assessmentOrgEnrollmentDetail",
			component: () =>
				import("@/components/assessment/orgEnrollmentDetail"),
			linkActiveClass: "active",
			meta: {
				title: "定级详情"
			}
		},
		{
			path: "/assessment/parentDetail",
			name: "assessmentParentDetail",
			component: () =>
				import("@/components/assessment/parentDetail"),
			linkActiveClass: "active",
			meta: {
				title: "官方测评报名系统-家长端"
			}
		},
		{
			path: "/assessment/parentEnroll",
			name: "assessmentParentEnroll",
			component: () =>
				import("@/components/assessment/parentEnroll"),
			linkActiveClass: "active",
			meta: {
				title: "作品定级"
			}
		},
		{
			path: "/assessment/studentForm",
			name: "assessmentStudentForm",
			component: () =>
				import("@/components/assessment/studentForm"),
			linkActiveClass: "active",
			meta: {
				title: "学员档案"
			}
		},
		{
			path: "/assessment/gradeQuery",
			name: "assessmentGradeQuery",
			component: () =>
				import("@/components/assessment/gradeQuery"),
			linkActiveClass: "active",
			meta: {
				title: "成绩查询"
			}
		},
		{
			path: "/assessment/gradeDetail",
			name: "assessmentGradeDetail",
			component: () =>
				import("@/components/assessment/gradeDetail"),
			linkActiveClass: "active",
			meta: {
				title: "成绩详情"
			}
		},
		{
			path: "/assessment/myPromotion",
			name: "assessmentMyPromotion",
			component: () =>
				import("@/components/assessment/myPromotion"),
			linkActiveClass: "active",
			meta: {
				title: "我的推广"
			}
		},
		{
			path: "/assessment/myPromotionPayments",
			name: "assessmentMyPromotionPayments",
			component: () =>
				import("@/components/assessment/myPromotionPayments"),
			linkActiveClass: "active",
			meta: {
				title: "缴费信息"
			}
		},
		{
			path: "/entryBuy",
			name: "entryBuy",
			component: () =>
				import("@/components/spellGroup/entry/entryBuy"),
			linkActiveClass: "active",
			meta: {
				title: "报名活动"
			}
		},
		{
			path: "/entryBuy1", // 备用地址
			name: "entryBuy1",
			component: () =>
				import("@/components/spellGroup/entry/entryBuy"),
			linkActiveClass: "active",
			meta: {
				title: "报名活动"
			}
		},
		{
			path: "/entryOrderDetail",
			name: "entryOrderDetail",
			component: () =>
				import("@/components/spellGroup/entry/entryOrderDetail"),
			linkActiveClass: "active",
			meta: {
				title: "活动订单详情"
			}
		},
		{
			path: "/entryLotteryDraw",
			name: "entryLotteryDraw",
			component: () =>
				import("@/components/spellGroup/entry/entryLotteryDraw"),
			linkActiveClass: "active",
			meta: {
				title: "报名抽奖"
			}
		},
		{
			path: "/myOrder",
			name: "myOrder",
			component: () =>
				import("@/components/wode/myOrder"),
			linkActiveClass: "active",
			meta: {
				title: "我的订单"
			}
		},
		{
			path: "/intentionStudent/:isTeacher",
			name: "intentionStudent",
			component: () =>
				import("@/components/intention/intentionStudent.vue"),
			linkActiveClass: "active",
			meta: {
				title: "生源酷"
			}
		},
		{
			path: "/rule_description",
			name: "ruleDescription",
			component: () => import("@/components/intention/ruleDescription"),
			linkActiveClass: "active",
			meta: {
				title: "规则说明"
			}
		},
		{
			path: "/studentState/:id",
			name: "studentState",
			component: () =>
				import("@/components/intention/studentState.vue"),
			linkActiveClass: "active",
			meta: {
				title: "学员状态"
			}
		},
		{
			path: "/studentInteract/:id",
			name: "studentInteract",
			component: () =>
				import("@/components/intention/studentInteract.vue"),
			linkActiveClass: "active",
			meta: {
				title: "沟通记录"
			}
		},
		{
			path: "/studentAudition/:id",
			name: "studentAudition",
			component: () =>
				import("@/components/intention/studentAudition.vue"),
			linkActiveClass: "active",
			meta: {
				title: "试听记录"
			}
		},
		{
			path: "/publicPool",
			name: "publicPool",
			component: () =>
				import("@/components/intention/publicPool.vue"),
			linkActiveClass: "active",
			meta: {
				title: "服务专员公有池"
			}
		},
		{
			path: "/studentInfo/:id",
			name: "studentInfo",
			component: () =>
				import("@/components/intention/studentInfo.vue"),
			linkActiveClass: "active",
			meta: {
				title: "学员信息"
			}
		},
		{
			path: "/addAudition/:id?",
			name: "addAudition",
			component: () =>
				import("@/components/intention/addAudition.vue"),
			linkActiveClass: "active",
			meta: {
				title: "新增试听"
			}
		},
		{
			path: "/addInteract/:is_student_id?",
			name: "addInteract",
			component: () =>
				import("@/components/intention/addInteract.vue"),
			linkActiveClass: "active",
			meta: {
				title: "新增沟通"
			}
		},
		{
			path: "/editInteract/:id",
			name: "editInteract",
			component: () =>
				import("@/components/intention/addInteract.vue"),
			linkActiveClass: "active",
			meta: {
				title: "修改沟通"
			}
		},
		{
			path: "/channelManage",
			name: "channelManage",
			component: () =>
				import("@/components/intention/channelManage.vue"),
			linkActiveClass: "active",
			meta: {
				title: "渠道管理"
			}
		},
		{
			path: "/importStudent",
			name: "importStudent",
			component: () =>
				import("@/components/intention/importStudent.vue"),
			linkActiveClass: "active",
			meta: {
				title: "导入意向学员"
			}
		},
		{
			path: "/afterWork/:isTeacher",
			name: "afterWork",
			component: () =>
				import("@/components/jigou/afterWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课后作业"
			}
		},
		{
			path: "/workStatistics/:isMy",
			name: "workStatistics",
			component: () =>
				import("@/components/jigou/workStatistics.vue"),
			linkActiveClass: "active",
			meta: {
				title: "我的学员作业统计"
			}
		},
		{
			path: "/afterWorkDetail/:id",
			name: "afterWorkDetail",
			component: () =>
				import("@/components/jigou/afterWorkDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课后作业"
			}
		},
		{
			path: "/arrangeWork",
			name: "arrangeWork",
			component: () =>
				import("@/components/jigou/arrangeWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "布置作业"
			}
		},
		{
			path: "/editWork/:id",
			name: "arrangeWork",
			component: () =>
				import("@/components/jigou/arrangeWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "编辑作业"
			}
		},
		{
			path: "/commentWork/:id",
			name: "commentWork",
			component: () =>
				import("@/components/jigou/commentWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "点评作品"
			}
		},
		{
			path: "/editComment/:id",
			name: "editComment",
			component: () =>
				import("@/components/jigou/commentWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "修改点评"
			}
		},
		{
			path: "/studentWork/:studentId/:id",
			name: "studentWork",
			component: () =>
				import("@/components/jigou/studentWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课后作业"
			}
		},
		{
			path: "/submitStudentWork/:studentId/:workId",
			name: "submitStudentWork",
			component: () =>
				import("@/components/jigou/submitStudentWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "提交作业"
			}
		},
		{
			path: "/editStudentWork/:studentId/:workId/:id",
			name: "editStudentWork",
			component: () =>
				import("@/components/jigou/submitStudentWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "修改作业"
			}
		},
		{
			path: "/homeStudentWork/:id",
			name: "homeStudentWork",
			component: () =>
				import("@/components/jigou/homeStudentWork.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课后作业"
			}
		},
		{
			path: "/clock_list",
			name: "clockList",
			component: () =>
				import("@/components/punch_the_clock/clockList.vue"),
			linkActiveClass: "active",
			meta: {
				title: "打卡活动"
			}
		},
		{
			path: "/add_clock",
			name: "editClock",
			component: () =>
				import("@/components/punch_the_clock/editClock.vue"),
			linkActiveClass: "active",
			meta: {
				title: "创建打卡活动"
			}
		},
		{
			path: "/edit_clock/:id",
			name: "editClock",
			component: () =>
				import("@/components/punch_the_clock/editClock.vue"),
			linkActiveClass: "active",
			meta: {
				title: "编辑打卡活动"
			}
		},
		{
			path: "/clock_detail/:id",
			name: "clockDetail",
			component: () =>
				import("@/components/punch_the_clock/clockDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "打卡详情"
			}
		},
		{
			path: "/clock_roster/:id",
			name: "clockRoster",
			component: () =>
				import("@/components/punch_the_clock/clockRoster.vue"),
			linkActiveClass: "active",
			meta: {
				title: "名单"
			}
		},
		{
			path: "/student_clock/:id/:student_id",
			name: "studentClock",
			component: () =>
				import("@/components/punch_the_clock/studentClock.vue"),
			linkActiveClass: "active",
			meta: {
				title: "打卡"
			}
		},
		{
			path: "/today_clock/:id/:student_id",
			name: "todayClock",
			component: () =>
				import("@/components/punch_the_clock/todayClock.vue"),
			linkActiveClass: "active",
			meta: {
				title: "今日打卡"
			}
		},
		{
			path: "/today_clock_edit/:id/:student_id/:log_id",
			name: "todayClockEdit",
			component: () =>
				import("@/components/punch_the_clock/todayClock.vue"),
			linkActiveClass: "active",
			meta: {
				title: "今日打卡"
			}
		},
		{
			path: "/clock_ranking/:id",
			name: "clockRanking",
			component: () =>
				import("@/components/punch_the_clock/clockRanking.vue"),
			linkActiveClass: "active",
			meta: {
				title: "打卡排名"
			}
		},
		{
			path: "/student_clock_list/:id",
			name: "studentClockList",
			component: () =>
				import("@/components/punch_the_clock/studentClockList.vue"),
			linkActiveClass: "active",
			meta: {
				title: "打卡活动"
			}
		},
		{
			path: "/teaching_resources",
			name: "teachingResources",
			component: () =>
				import("@/components/jigou/teachingResources.vue"),
			linkActiveClass: "active",
			meta: {
				title: "教学资源"
			}
		},
		{
			path: "/ai_growth_report_records",
			name: "aiGrowthReportRecords",
			component: () =>
				import("@/components/growthReport/ai_growth_report_records.vue"),
			linkActiveClass: "active",
			meta: {
				title: "生成记录"
			}
		},
		{
			path: "/ai_growth_report_detail/:id",
			name: "aiGrowthReportDetail",
			component: () =>
				import("@/components/growthReport/ai_growth_report_detail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "成长报告"
			}
		},
		{
			path: "/ai_growth_report_edit/:id",
			name: "aiGrowthReportEdit",
			component: () =>
				import("@/components/growthReport/ai_growth_report_edit.vue"),
			linkActiveClass: "active",
			meta: {
				title: "编辑成长报告"
			}
		},
		{
			path: "/ai_growth_report_package",
			name: "aiGrowthReportPackage",
			component: () =>
				import("@/components/growthReport/ai_growth_report_package.vue"),
			linkActiveClass: "active",
			meta: {
				title: "套餐中心"
			}
		},
		{
			path: "/ai_growth_report_generate",
			name: "ai_growth_report_generate",
			component: () =>
				import("@/components/growthReport/ai_growth_report_generate.vue"),
			linkActiveClass: "active",
			meta: {
				title: "人工生成成长报告"
			}
		},
		{
			path: "/ai_growth_report_plan_intro",
			name: "ai_growth_report_plan_intro",
			component: () =>
				import("@/components/growthReport/ai_growth_report_plan_intro.vue"),
			linkActiveClass: "active",
			meta: {
				title: "年度成长规划"
			}
		},
		{
			path: "/ai_growth_report_plan_generate",
			name: "ai_growth_report_plan_generate",
			component: () =>
				import("@/components/growthReport/ai_growth_report_plan_generate.vue"),
			linkActiveClass: "active",
			meta: {
				title: "生成规划报告"
			}
		},
		{
			path: "/ai_growth_report_plan_edit/:id",
			name: "ai_growth_report_plan_edit",
			component: () =>
				import("@/components/growthReport/ai_growth_report_plan_edit.vue"),
			linkActiveClass: "active",
			meta: {
				title: "编辑规划报告"
			}
		},
		{
			path: "/ai_growth_report_plan_detail/:id",
			name: "ai_growth_report_plan_detail",
			component: () =>
				import("@/components/growthReport/ai_growth_report_plan_detail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "年度成长规划"
			}
		},
		{
			path: "/ai_growth_report_classes",
			name: "ai_growth_report_classes",
			component: () =>
				import("@/components/growthReport/ai_growth_report_classes.vue"),
			linkActiveClass: "active",
			meta: {
				title: "自动生成报告班级"
			}
		},
		{
			path: "/ai_growth_report",
			name: "ai_growth_report",
			component: () =>
				import("@/components/growthReport/ai_growth_report.vue"),
			linkActiveClass: "active",
			meta: {
				title: "AI成长报告"
			}
		},
		{
			path: "/teaching_detail/:id",
			name: "teachingDetail",
			component: () =>
				import("@/components/jigou/teachingDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "教学资源"
			}
		},
		{
			path: "/ppt_detail/:id",
			name: "pptDetail",
			component: () =>
				import("@/components/jigou/pptDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "教学资源"
			}
		},
		{
			path: "/partner",
			name: "partner",
			component: () =>
				import("@/components/partner/index.vue"),
			linkActiveClass: "active",
			meta: {
				title: "合伙人创收"
			}
		},
		{
			path: "/maintenance_deduct",
			name: "maintenanceDeduct",
			component: () =>
				import("@/components/partner/maintenanceDeduct.vue"),
			linkActiveClass: "active",
			meta: {
				title: "维护扣费项目"
			}
		},
		{
			path: "/lottery/edit",
			name: "lotteryEdit",
			component: () =>
				import("@/components/lottery/edit.vue"),
			linkActiveClass: "active",
			meta: {
				title: "全勤有奖",
				keepAlive: true
			}
		},
		{
			path: "/lottery/detail/:id",
			name: "lotteryDetail",
			component: () =>
				import("@/components/lottery/detail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "抽奖",
				keepAlive: true
			}
		},
		{
			path: "/lottery/roster/:id",
			name: "lotteryRoster",
			component: () =>
				import("@/components/lottery/roster.vue"),
			linkActiveClass: "active",
			meta: {
				title: "抽奖名单",
				keepAlive: true
			}
		},
		{
			path: "/lottery/verify/:id",
			name: "lotteryVerify",
			component: () =>
				import("@/components/lottery/verify.vue"),
			linkActiveClass: "active",
			meta: {
				title: "出勤抽奖核销",
				keepAlive: true
			}
		},
		{
			path: "/face/list",
			name: "faceList",
			component: () =>
				import("@/components/face/list.vue"),
			linkActiveClass: "active",
			meta: {
				title: "学员人脸",
				keepAlive: true
			}
		},
		{
			path: "/face/collect/:id",
			name: "faceCollect",
			component: () =>
				import("@/components/face/collect.vue"),
			linkActiveClass: "active",
			meta: {
				title: "人脸采集",
				keepAlive: true
			}
		},
		{
			path: "/watingSchool",
			name: "watingSchool",
			component: () =>
				import("@/components/new_profile/watingSchool.vue"),
			linkActiveClass: "active",
			meta: {
				title: "待入校分班生",
				keepAlive: true
			}
		},
		{
			path: "/effectiveHour",
			name: "effectiveHour",
			component: () =>
				import("@/components/new_profile/effectiveHour.vue"),
			linkActiveClass: "active",
			meta: {
				title: "课时有效期学员",
				keepAlive: true
			}
		},
		{
			path: "/message",
			name: "message",
			component: () =>
				import("@/components/message/index.vue"),
			linkActiveClass: "active",
			meta: {
				title: "消息通知",
				keepAlive: true
			}
		},
		{
			path: "/message/statistics",
			name: "statistics",
			component: () =>
				import("@/components/message/statistics.vue"),
			linkActiveClass: "active",
			meta: {
				title: "学员沟通统计",
				keepAlive: true
			}
		},
		{
			path: "/message/sending",
			name: "sending",
			component: () =>
				import("@/components/message/sending.vue"),
			linkActiveClass: "active",
			meta: {
				title: "消息群发",
				keepAlive: true
			}
		},
		{
			path: "/message/preview/:id",
			name: "preview",
			component: () =>
				import("@/components/message/preview.vue"),
			linkActiveClass: "active",
			meta: {
				title: "预览模板",
				keepAlive: true
			}
		},
		{ //1 模板 2 修改 3 转发
			path: "/message/edit/:id/:status",
			name: "editNotice",
			component: () =>
				import("@/components/message/editNotice.vue"),
			linkActiveClass: "active",
			meta: {
				title: "发布通知",
				keepAlive: true
			}
		},
		{
			path: "/message/notice/detail/:id",
			name: "noticeDetail",
			component: () =>
				import("@/components/message/noticeDetail.vue"),
			linkActiveClass: "active",
			meta: {
				title: "通知详情",
				keepAlive: true
			}
		},
		{
			path: "/message/chat/:id/:student_id",
			name: "chat",
			component: () =>
				import("@/components/message/chat.vue"),
			linkActiveClass: "active",
			meta: {
				title: "专属群",
				keepAlive: true
			}
		},
		{
			path: "/message/notice/comment/:id",
			name: "noticeComment",
			component: () =>
				import("@/components/message/noticeComment.vue"),
			linkActiveClass: "active",
			meta: {
				title: "通知详情",
				keepAlive: true
			}
		},
		{
			path: "/jigsaw/:id",
			name: "jigsaw",
			component: () =>
				import("@/components/jigsaw/index.vue"),
			linkActiveClass: "active",
			meta: {
				title: "选择作品",
				keepAlive: true
			}
		},
		{
			path: "/parent_list",
			name: "parentList",
			component: () =>
				import("@/components/message/parentList.vue"),
			linkActiveClass: "active",
			meta: {
				title: "学员信息",
				keepAlive: true
			}
		},
		{
			path: '/videoCourses/:id',
			// path: '/videoCourses/1',
			name: 'VideoCourses',
			component: () => import("@/components/videos/videoCourses.vue"),
			linkActiveClass: "active",
			meta: {
				title: "视频课程"
			},
		},
		{
			path: '/videoPreview',
			name: 'videoPreview',
			component: () => import("@/components/videos/videoPreview.vue"),
			linkActiveClass: "active",
			meta: {
				title: "视频播放"
			},
		},
		{
			path: '/RealAuthenticationSigning',
			name: 'RealAuthenticationSigning',
			component: () => import("@/components/wallet/RealAuthenticationSigning.vue"),
			linkActiveClass: "active",
			meta: {
				title: "实名认证签约"
			},
		},
		{
			path: '/RealAuthenticationSigningForeign',
			name: 'RealAuthenticationSigningForeign',
			component: () => import("@/components/wallet/RealAuthenticationSigningForeign.vue"),
			linkActiveClass: "active",
			meta: {
				title: "港澳台外籍居民认证签约"
			},
		},
		{
			path: '/FlexibleEmploymentAgreement',
			name: 'FlexibleEmploymentAgreement',
			component: () => import("@/components/wallet/FlexibleEmploymentAgreement.vue"),
			linkActiveClass: "active",
			meta: {
				title: "云账户灵活就业合作伙伴协议"
			},
		}
	]
})



// WEBPACK FOOTER //
// ./src/utils/home.js